import { ProductionQuantityLimits } from "@mui/icons-material";
import React, { useState, useEffect } from "react";
import { FaEdit } from "react-icons/fa";
import apiService from "../../service/apiService";
import { Download } from "@mui/icons-material";
import { Menu, Box, Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Typography, TextField, Select, MenuItem, Autocomplete, CircularProgress, Grid, FormControl, InputLabel } from "@mui/material";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import { format, parseISO } from "date-fns";
import { Pagination, Table } from "react-bootstrap";

const CropPlan = ({ reportName }) => {
  const [filteredRows, setFilteredRows] = useState([]);
  const [villageName, setvillageName] = useState("");
  const [gpName, setgpName] = useState("");
  const [blockName, setBlock] = useState("");
  const [districtName, setDistrict] = useState("");
  const [mipName, setMip] = useState("");
  const [farmername, setFarmerName] = useState("");
  const [gender, setGender] = useState("");
  const [caste, setCaste] = useState("");
  const [pgcode, setPgCode] = useState("");
  const [pgName, setPgName] = useState("");
  const [seedName, setSeedName] = useState("");
  const [className, setClassName] = useState("");
  const [varietyName, setVarietyName] = useState("");
  const [cropType, setCropType] = useState("");
  const [page, setPage] = useState(1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [season, setSeason] = useState("");
  const [seasonName, setseasonName] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [totalItems, setTotalitems] = useState(0);
  const [totalpage, setTotalpage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectedSeasonId, setSelectedSeasonId] = useState(0);

  const [genders, setGenders] = useState([]);
  const [selectedGenderId, setSelectedGenderId] = useState(0);
  const [castes, setCastes] = useState([]);
  const [selectedCasteId, setSelectedCasteId] = useState(0);
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [plannedarea, setPlannedarea] = useState('');
  const [seedSowingDate, setSeedSowingDate] = useState("");


  const fetchData = async () => {
    try {
      const payload = {
        seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
        casteId: selectedCasteId ? Number(selectedCasteId) : 0,
        genderId: selectedGenderId ? Number(selectedGenderId) : 0,
        farmerName: farmername,
        pgCode: pgcode,
        pgName: pgName,
        seedName: seedName,
        cropType: cropType,
        plannedArea: plannedarea ? parseFloat(plannedarea) : 0.0,
        className: className,
        varietyName: varietyName,
        villageName: villageName,
        gpName: gpName,
        blockName: blockName,
        districtName: districtName,
        mipName: mipName,
        yearValue: year ? Number(year) : null, // Ensure it's a number or null
        userId: 0,
        pageNumber: page,
        pageSize: pageSize,
        seedSowingDate: seedSowingDate || "",
      };

      const response = await apiService.post("/crop-plan-master/getReport", payload);

      if (response.data.status) {
        const data = response.data.body.data || [];
        const totalRecords = response.data.body.recordsCount || 0;
        const totalPages = pageSize > 0 ? Math.ceil(totalRecords / pageSize) : 0;

        setFilteredRows(data);
        setTotalitems(totalRecords);
        setTotalpage(totalPages);
        setRows(data);
        setRowCount(totalRecords);
      } else {
        setFilteredRows([]);
        setTotalitems(0);
        setTotalpage(0);
        setRows([]);
        setRowCount(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    villageName, gpName, blockName, districtName, mipName, seasonName, farmername,
    caste, pgcode, pgName, seedName, className, varietyName, cropType,
    page, pageSize, year, selectedSeasonId, selectedGenderId, selectedCasteId, plannedarea, seedSowingDate
  ]);


  const handleDateChange = (e) => {
    const inputDate = e.target.value; // Format is YYYY-MM-DD
    const formattedDate = formatDate(inputDate);
    setSeedSowingDate(formattedDate);
    setPage(1); // Assuming setPage is defined elsewhere
  };

  const formatDate = (date) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`; // Convert YYYY-MM-DD → DD-MM-YYYY
  };
  const fetchYears = async () => {
    try {
      const response = await apiService.get("/years/get-all");
      setYears(response.data);
      const currentYear = new Date().getFullYear();
      const defaultYear = response.data.find((yr) => yr.yearValue === currentYear);

      setYear(defaultYear ? defaultYear.yearValue : response.data[0].yearValue);
    } catch (error) {
      console.error("Error fetching years:", error);
    }
  };
  const fetchSeasons = async () => {
    try {
      const response = await apiService.get("/seasons/get-all");
      setSeasons(response.data);
    } catch (error) {
      console.error("Error fetching seasons:", error);
    }
  };

  const fetchGenders = async () => {
    try {
      const response = await apiService.get("/master/get-all-gender");
      setGenders(response.data || []);
    } catch (error) {
      console.error("Error fetching genders:", error);
    }
  };
  const fetchCastes = async () => {
    try {
      const response = await apiService.get("/castes/get-all");
      setCastes(response.data);
    } catch (error) {
      console.error("Error fetching castes:", error);
    }
  };

  useEffect(() => {

    fetchYears();
    fetchSeasons();
    fetchGenders();
    fetchCastes();
  }, []);

  const handleSeasonChange = (event) => {
    setSelectedSeasonId(event.target.value);
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const startItem = (page - 1) * 10 + 1;
  const endItem = Math.min(page * 10, totalItems);

  const renderPaginationItems = () => {
    const paginationItems = [];
    const maxPagesToShow = 7;
    const startPages = 3;
    const endPages = 2;

    if (totalpage <= maxPagesToShow) {
      for (let pages = 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    } else {
      for (let pages = 1; pages <= startPages; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      if (page > startPages + 1) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }

      const middlePages = [];
      const startMiddlePage = Math.max(page - 1, startPages + 1);
      const endMiddlePage = Math.min(page + 1, totalpage - endPages);

      for (let pages = startMiddlePage; pages <= endMiddlePage; pages++) {
        middlePages.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      paginationItems.push(...middlePages);

      if (page < totalpage - endPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      for (let pages = totalpage - endPages + 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    }
    return paginationItems;
  };


  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const exportToCSV = async (selectedYear) => {
    try {
      const payload = {
        seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
        casteId: selectedCasteId ? Number(selectedCasteId) : 0,
        genderId: selectedGenderId ? Number(selectedGenderId) : 0,
        farmerName: farmername,
        pgCode: pgcode,
        pgName: pgName,
        seedName: seedName,
        cropType: cropType,
        plannedarea: plannedarea,
        className: className,
        varietyName: varietyName,
        villageName: villageName,
        gpName: gpName,
        blockName: blockName,
        districtName: districtName,
        mipName: mipName,
        yearValue: year ? Number(year) : null,
        userId: 0,
        pageNumber: page,
        pageSize: pageSize,
      };

      const response = await apiService.post("/crop-plan-master/getReport", payload);

      if (response.data.status) {
        const data = response.data.body.data || [];

        if (data.length === 0) {
          alert("No data available to export.");
          return;
        }

        // Define headers in required order
        const headers = [
          "Village", "GP", "Block", "District", "MIP", "Season", "Gender",
          "Farmer Name", "Caste", "PG Code", "PG Name",
          "Seed Name", "Seed Class", "Seed Variety", "Crop Type", "Total PlannedArea", "Planned Area", "Lease Area", "Seed Sowing Date"
        ];

        // Map data to match the header order
        const rows = data.map(item => [
          item.villageName || "",
          item.gpName || "",
          item.blockName || "",
          item.districtName || "",
          item.mipName || "",
          item.seasonName || "",
          item.gender || "",
          item.farmerName || "",
          item.caste || "",
          item.pgCode || "",
          item.pgName || "",
          item.seedName || "",
          item.className || "",
          item.varietyName || "",
          item.cropType || "",
          item.totalPlannedArea || "",
          item.plannedArea || "",
          item.leaseArea || "",
          item.seedSowingDate ? format(parseISO(item.seedSowingDate), "dd-MM-yyyy") : "N/A" || ""
        ]);

        // Convert array to CSV format
        const csvContent = [
          `Report: ${reportName}`,
          `Year: ${selectedYear}`,
          headers.join(","),
          ...rows.map(row => row.map(value => `"${value}"`).join(",")) // Ensure values with commas are wrapped in quotes
        ].join("\n");

        // Create and download CSV file
        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${reportName.replace(/\s+/g, '_')}_${selectedYear}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        alert("Failed to fetch data from API.");
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      alert("An error occurred while fetching data.");
    }
  };



  const exportToXLSX = async (selectedYear) => {
    try {
      const payload = {
        seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
        casteId: selectedCasteId ? Number(selectedCasteId) : 0,
        genderId: selectedGenderId ? Number(selectedGenderId) : 0,
        farmerName: farmername,
        pgCode: pgcode,
        pgName: pgName,
        seedName: seedName,
        cropType: cropType,
        plannedarea: plannedarea,
        className: className,
        varietyName: varietyName,
        villageName: villageName,
        gpName: gpName,
        blockName: blockName,
        districtName: districtName,
        mipName: mipName,
        yearValue: year ? Number(year) : null,
        userId: 0,
        pageNumber: page,
        pageSize: pageSize,
      };

      const response = await apiService.post("/crop-plan-master/getReport", payload);

      if (response.data.status) {
        const data = response.data.body.data || [];

        if (data.length === 0) {
          alert("No data available to export.");
          return;
        }

        // Define headers in required order
        const headers = [
          "Village", "GP", "Block", "District", "MIP", "Season", "Gender",
          "Farmer Name", "Caste", "PG Code", "PG Name",
          "Seed Name", "Seed Class", "Seed Variety", "Crop Type", "Total PlannedArea", "Planned Area", "Lease Area", "Seed Sowing Date"
        ];

        // Map data to match the header order
        const rows = data.map(item => [
          item.villageName || "",
          item.gpName || "",
          item.blockName || "",
          item.districtName || "",
          item.mipName || "",
          item.seasonName || "",
          item.gender || "",
          item.farmerName || "",
          item.caste || "",
          item.pgCode || "",
          item.pgName || "",
          item.seedName || "",
          item.className || "",
          item.varietyName || "",
          item.cropType || "",
          item.totalPlannedArea || "",
          item.plannedArea || "",
          item.leaseArea || "",
          item.seedSowingDate ? format(parseISO(item.seedSowingDate), "dd-MM-yyyy") : "N/A" || ""


        ]);

        // Create worksheet
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Generate filename
        const fileName = `${reportName.replace(/\s+/g, '_')}_${selectedYear}.xlsx`;
        XLSX.writeFile(workbook, fileName);
      } else {
        alert("Failed to fetch data from API.");
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      alert("An error occurred while fetching data.");
    }
  };






  return (
    <div className="container-fluid" style={{ maxHeight: "100vh", overflowX: "auto" }}>      {/* Fixed Year & Season Selection Section */}
      <div className="row mt-3">
        <div className="d-flex align-items-center me-4 p-2 bg-white shadow-sm"
          style={{ position: "sticky", top: 0, zIndex: 10 }}>

          <div className="d-flex align-items-center me-3">
            <div className="me-2 fw-bold">Year</div>
            <select
              className="form-select form-select-sm"
              style={{ width: "100px" }}
              value={year || 0}
              onChange={(e) => {
                setYear(Number(e.target.value));
              }}
            >
              <option value={0} disabled>Select a Year</option>
              {years.map((yr) => (
                <option key={yr.yearId} value={yr.yearValue}>
                  {yr.yearValue}
                </option>
              ))}
            </select>

            <div className="d-flex align-items-center">
              {/* <div className="me-2 fw-bold">Season</div> */}
              {/* <select
              className="form-select form-select-sm"
              style={{ width: "120px" }}
              value={season || ""}
              onChange={(e) => {
                setSeason(Number(e.target.value));  // Storing seasonId
              }}
            >
              <option value="" disabled>Select Season</option>
              {seasons.map((sn) => (
                <option key={sn.seasonId} value={sn.seasonId}>
                  {sn.seasonName}
                </option>
              ))}
            </select> */}



              <Button
                variant="contained"
                color="primary"
                sx={{
                  marginLeft: "20px",
                  padding: "10px 20px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "none",
                  borderRadius: "12px",
                  background: "linear-gradient(90deg, #1976d2, #42a5f5)",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                  "&:hover": {
                    background: "linear-gradient(90deg, #1565c0, #2196f3)",
                  },
                }}
                startIcon={<Download />}
                onClick={handleMenuOpen}
              >
                Export Data
              </Button>

              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem onClick={() => { exportToCSV(year); handleMenuClose(); }}>Download as CSV</MenuItem>
                <MenuItem onClick={() => { exportToXLSX(year); handleMenuClose(); }}>Download as XLSX</MenuItem>
              </Menu>
            </div>

          </div>

        </div></div>
      <div className="row mt-3">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body table-responsive p-0"
              style={{
                minHeight: "60vh",
                overflowX: "auto",
                scrollbarWidth: "thin",
                scrollbarColor: "#ccc transparent",
              }}>
              <table className="table table-hover table-bordered text-nowrap mb-0">
                <thead>
                  <tr>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Village
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={villageName}
                        onChange={(e) => {
                          setvillageName(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      GP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={gpName}
                        onChange={(e) => {
                          setgpName(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Block
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={blockName}
                        onChange={(e) => {
                          setBlock(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      District
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={districtName}
                        onChange={(e) => {
                          setDistrict(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      MIP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={mipName}
                        onChange={(e) => {
                          setMip(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Season
                      <br />
                      <select
                        className="form-control form-control-sm"
                        value={selectedSeasonId}
                        onChange={(e) => {
                          setSelectedSeasonId(e.target.value);
                          setPage(1);
                        }}
                      >
                        <option value={0}>All</option>
                        {seasons.map((season) => (
                          <option key={season.seasonId} value={season.seasonId}>
                            {season.seasonName}
                          </option>
                        ))}
                      </select>
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Farmer Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={farmername}
                        onChange={(e) => {
                          setFarmerName(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>

                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Gender
                      <br />
                      <select
                        className="form-control form-control-sm"
                        value={selectedGenderId}
                        onChange={(e) => {
                          setSelectedGenderId(e.target.value);
                          setPage(1);
                        }}
                      >
                        <option value="">All</option>
                        {genders.map((gender) => (
                          <option key={gender.genderId} value={gender.genderId}>
                            {gender.gender}
                          </option>
                        ))}
                      </select>
                    </th>


                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Caste
                      <br />
                      <select
                        className="form-control form-control-sm"
                        value={selectedCasteId || ""}
                        onChange={(e) => {
                          setSelectedCasteId(e.target.value ? Number(e.target.value) : null);
                          setPage(1);
                        }}
                      >
                        <option value="">All</option>
                        {castes.map((caste) => (
                          <option key={caste.casteId} value={caste.casteId}>
                            {caste.caste}
                          </option>
                        ))}
                      </select>
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>PG Code
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={pgcode}
                        onChange={(e) => {
                          setPgCode(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>PG Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={pgName}
                        onChange={(e) => {
                          setPgName(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Seed Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={seedName}
                        onChange={(e) => {
                          setSeedName(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Seed Class
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={className}
                        onChange={(e) => {
                          setClassName(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Seed Variety
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={varietyName}
                        onChange={(e) => {
                          setVarietyName(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Crop Type
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={cropType}
                        onChange={(e) => {
                          setCropType(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}> Total Planned Area
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={plannedarea}
                onChange={(e) => {
                  setPlannedarea(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Planned Area
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={plannedarea}
                onChange={(e) => {
                  setPlannedarea(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>



                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Lease Area
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={plannedarea}
                onChange={(e) => {
                  setPlannedarea(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>

                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Sowing Date
                      <br />
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={seedSowingDate}
                        onChange={(e) => {
                          setSeedSowingDate(e.target.value);
                        }}
                      />
                    </th>

                  </tr>
                </thead>
                <tbody style={{ fontSize: "14px" }}>
                  {filteredRows.map((data, index) => (
                    <tr key={index}>
                      <td className="py-1">{data.villageName}</td>
                      <td className="py-1">{data.gpName}</td>
                      <td className="py-1">{data.blockName}</td>
                      <td className="py-1">{data.districtName}</td>
                      <td className="py-1">{data.mipName}</td>
                      <td className="py-1">{data.seasonName}</td>
                      <td className="py-1">{data.farmerName}</td>
                      <td className="py-1">{data.gender}</td>
                      <td className="py-1">{data.caste}</td>
                      <td className="py-1">{data.pgCode}</td>
                      <td className="py-1">{data.pgName}</td>
                      <td className="py-1">{data.seedName}</td>
                      <td className="py-1">{data.className}</td>
                      <td className="py-1">{data.varietyName}</td>
                      <td className="py-1">{data.cropType}</td>
                      <td className="py-1">{data.totalPlannedArea}</td>
                      <td className="py-1">{data.plannedArea}</td>
                      <td className="py-1">{data.leaseArea}</td>
                      <td className="py-1">{data.seedSowingDate ? format(parseISO(data.seedSowingDate), "dd-MM-yyyy") : "N/A"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div></div></div></div>

      <div className="row mt-3">
        <div className='d-flex justify-content-between pb-0'>
          <div className='p-2'>
            Showing {startItem} to {endItem} of {totalItems} items
          </div>
          <div className='p-2'>
            <Pagination className="mb-0">
              <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
              <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
              {renderPaginationItems()}
              <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalpage} />
              <Pagination.Last onClick={() => handlePageChange(totalpage)} disabled={page === totalpage} />
            </Pagination>
          </div>
        </div>
      </div>

    </div>

  );
};

const CropCulltivation = ({ reportName }) => {
  const [filteredRows, setFilteredRows] = useState([]);
  const [village, setVillage] = useState("");
  const [gp, setGp] = useState("");
  const [block, setBlock] = useState("");
  const [district, setDistrict] = useState("");
  const [mip, setMip] = useState("");
  const [farmerName, setFarmerName] = useState("");
  const [gender, setGender] = useState("");
  const [caste, setCaste] = useState("");
  const [pgcode, setPgCode] = useState("");
  const [pgName, setPgName] = useState("");
  const [seedName, setSeedName] = useState("");
  const [seedClass, setSeedClass] = useState("");
  const [seedVariety, setSeedVariety] = useState("");
  const [cropType, setCropType] = useState("");
  const [cultivatedArea, setCultivatedArea] = useState("");
  const [page, setPage] = useState(1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [season, setSeason] = useState("");
  const [seasonName, setseasonName] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [totalItems, setTotalitems] = useState(0);
  const [totalpage, setTotalpage] = useState(0);
  const [selectedSeasonId, setSelectedSeasonId] = useState(0);
  const [genders, setGenders] = useState([]);
  const [selectedGenderId, setSelectedGenderId] = useState(0);
  const [castes, setCastes] = useState([]);
  const [selectedCasteId, setSelectedCasteId] = useState(0);

  const [pageSize, setPageSize] = useState(10);
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [plannedarea, setPlannedarea] = useState('');

  const fetchYears = async () => {
    try {
      const response = await apiService.get("/years/get-all");
      setYears(response.data);
      const currentYear = new Date().getFullYear();
      const defaultYear = response.data.find((yr) => yr.yearValue === currentYear);

      setYear(defaultYear ? defaultYear.yearValue : response.data[0].yearValue);
    } catch (error) {
      console.error("Error fetching years:", error);
    }
  };


  useEffect(() => {
    fetchData();
  }, [farmerName, pgcode, pgName, seedName, cropType, seedClass, seedVariety, village, gp, block, district, mip, cultivatedArea, year,
    selectedSeasonId, selectedGenderId, selectedCasteId, page, pageSize, plannedarea,]);
  const fetchData = async () => {
    try {
      const payload = {
        seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
        genderId: selectedGenderId ? Number(selectedGenderId) : 0,
        casteId: selectedCasteId ? Number(selectedCasteId) : 0,
        farmerName: farmerName,
        pgCode: pgcode,
        pgName: pgName,
        seedName: seedName,
        cropType: cropType,
        plannedArea: plannedarea ? parseFloat(plannedarea) : 0.0,
        className: seedClass,
        varietyName: seedVariety,
        villageName: village,
        gpName: gp,
        blockName: block,
        districtName: district,
        mipName: mip,
        year: year,
        cultivatedArea: cultivatedArea ? parseFloat(cultivatedArea) : 0.0,
        userId: 0,
        pageNumber: page,
        pageSize: 10,
      };




      const response = await apiService.post("/crop-master/cultivationReport", payload);

      if (response.data.status) {
        const data = response.data.body.data || [];
        const totalRecords = response.data.body.recordsCount || 0;
        const totalPages = pageSize > 0 ? Math.ceil(totalRecords / pageSize) : 0;

        setFilteredRows(data);
        setTotalitems(totalRecords);
        setTotalpage(totalPages);
        setRows(data);
        setRowCount(totalRecords);
      } else {
        setFilteredRows([]);
        setTotalitems(0);
        setTotalpage(0);
        setRows([]);
        setRowCount(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };



  const fetchSeasons = async () => {
    try {
      const response = await apiService.get("/seasons/get-all");
      setSeasons(response.data);
    } catch (error) {
      console.error("Error fetching seasons:", error);
    }
  };

  const fetchGenders = async () => {
    try {
      const response = await apiService.get("/master/get-all-gender");
      setGenders(response.data || []);
    } catch (error) {
      console.error("Error fetching genders:", error);
    }
  };
  const fetchCastes = async () => {
    try {
      const response = await apiService.get("/castes/get-all");
      setCastes(response.data);
    } catch (error) {
      console.error("Error fetching castes:", error);
    }
  };
  useEffect(() => {

    fetchYears();
    fetchSeasons();
    fetchGenders();
    fetchCastes();
  }, []);


  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const startItem = (page - 1) * 10 + 1;
  const endItem = Math.min(page * 10, totalItems);

  const renderPaginationItems = () => {
    const paginationItems = [];
    const maxPagesToShow = 7;
    const startPages = 3;
    const endPages = 2;

    if (totalpage <= maxPagesToShow) {
      for (let pages = 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    } else {
      // Show first 3 pages
      for (let pages = 1; pages <= startPages; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      // Show ellipsis if necessary
      if (page > startPages + 1) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }

      // Show the middle pages around the current page
      const middlePages = [];
      const startMiddlePage = Math.max(page - 1, startPages + 1);
      const endMiddlePage = Math.min(page + 1, totalpage - endPages);

      for (let pages = startMiddlePage; pages <= endMiddlePage; pages++) {
        middlePages.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      paginationItems.push(...middlePages);

      // Show ellipsis if necessary
      if (page < totalpage - endPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      // Show last 2 pages
      for (let pages = totalpage - endPages + 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    }
    return paginationItems;
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };


  const exportToCSV = async (selectedYear) => {
    try {
      const payload = {
        seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
        casteId: selectedCasteId ? Number(selectedCasteId) : 0,
        genderId: selectedGenderId ? Number(selectedGenderId) : 0,
        farmerName: farmerName || "",
        pgCode: pgcode || "",
        pgName: pgName || "",
        seedName: seedName || "",
        cropType: cropType || "",
        plannedarea: plannedarea || "",
        className: seedClass || "",
        varietyName: seedVariety || "",
        villageName: village || "",
        gpName: gp || "",
        blockName: block || "",
        districtName: district || "",
        mipName: mip || "",
        year: year ? Number(year) : null,
        userId: 0,
        pageNumber: page || 1,
        pageSize: pageSize || 10,
      };

      const response = await apiService.post("/crop-master/cultivationReport", payload);

      if (response.data.status) {
        const data = response.data.body.data || [];

        if (data.length === 0) {
          alert("No data available to export.");
          return;
        }

        // Define headers in required order
        const headers = [
          "Village", "GP", "Block", "District", "MIP", "Season", "Gender",
          "Farmer Name", "Caste", "PG Code", "PG Name",
          "Seed Name", "Seed Class", "Seed Variety", "Crop Type", "Cultivated Area", "Total PlannedArea", "Lease Area", "Planned Area"
        ];

        // Map data to match the header order
        const rows = data.map(item => [
          item.village ?? "",
          item.gp ?? "",
          item.block ?? "",
          item.district ?? "",
          item.mip ?? "",
          item.seasonName ?? "",
          item.gender ?? "",
          item.farmerName ?? "",
          item.caste ?? "",
          item.pgCode ?? "",
          item.pgName ?? "",
          item.seedName ?? "",
          item.seedClass ?? "",
          item.seedVariety ?? "",
          item.cropType ?? "",
          item.cultivatedArea ?? "",
          item.totalPlannedArea ?? "",
          item.leaseArea ?? "",
          item.plannedArea ?? ""
        ]);

        // Convert array to CSV format
        const csvContent = [
          `Report: ${reportName}`,
          `Year: ${selectedYear}`,
          headers.join(","),
          ...rows.map(row => row.map(value => `"${value}"`).join(",")) // Ensure values with commas are wrapped in quotes
        ].join("\n");

        // Create and download CSV file
        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${reportName.replace(/\s+/g, '_')}_${selectedYear}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        alert("Failed to fetch data from API.");
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      alert("An error occurred while fetching data.");
    }
  };

  const exportToXLSX = async (selectedYear) => {
    try {
      const payload = {
        seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
        casteId: selectedCasteId ? Number(selectedCasteId) : 0,
        genderId: selectedGenderId ? Number(selectedGenderId) : 0,
        farmerName: farmerName || "",
        pgCode: pgcode || "",
        pgName: pgName || "",
        seedName: seedName || "",
        cropType: cropType || "",
        plannedarea: plannedarea || "",
        className: seedClass || "",
        varietyName: seedVariety || "",
        villageName: village || "",
        gpName: gp || "",
        blockName: block || "",
        districtName: district || "",
        mipName: mip || "",
        year: year ? Number(year) : null,
        userId: 0,
        pageNumber: page || 1,
        pageSize: pageSize || 10,
      };

      const response = await apiService.post("/crop-master/cultivationReport", payload);

      if (response.data.status) {
        const data = response.data.body.data || [];

        if (data.length === 0) {
          alert("No data available to export.");
          return;
        }

        // Define headers
        const headers = [
          "Village", "GP", "Block", "District", "MIP", "Season",
          "Farmer Name", "Gender", "Caste", "PG Code", "PG Name",
          "Seed Name", "Seed Class", "Seed Variety", "Crop Type", "Cultivated Area", "Total PlannedArea", "Lease Area", "Planned Area"
        ];

        // Map data to match headers
        const rows = data.map(item => [
          item.village ?? "",
          item.gp ?? "",
          item.block ?? "",
          item.district ?? "",
          item.mip ?? "",
          item.seasonName ?? "",
          item.farmerName ?? "",
          item.gender ?? "",
          item.caste ?? "",
          item.pgCode ?? "",
          item.pgName ?? "",
          item.seedName ?? "",
          item.seedClass ?? "",
          item.seedVariety ?? "",
          item.cropType ?? "",
          item.cultivatedArea ?? "",
          item.totalPlannedArea ?? "",
          item.leaseArea ?? "",
          item.plannedArea ?? ""
        ]);

        // Create worksheet
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Generate and download file
        const fileName = `Crop_Cultivation_Report_${selectedYear}.xlsx`;
        XLSX.writeFile(workbook, fileName);
      } else {
        alert("Failed to fetch data from API.");
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      alert("An error occurred while fetching data.");
    }
  };

  // const exportToPDF = async (selectedYear) => {
  //   try {
  //     const payload = {
  //       seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
  //       casteId: selectedCasteId ? Number(selectedCasteId) : 0,
  //       genderId: selectedGenderId ? Number(selectedGenderId) : 0,
  //       farmerName: farmerName || "",
  //       pgCode: pgcode || "",
  //       pgName: pgName || "",
  //       seedName: seedName || "",
  //       cropType: cropType || "",
  //       plannedarea: plannedarea || "",
  //       className: seedClass || "",
  //       varietyName: seedVariety || "",
  //       villageName: village || "",
  //       gpName: gp || "",
  //       blockName: block || "",
  //       districtName: district || "",
  //       mipName: mip || "",
  //       year: year ? Number(year) : null,
  //       userId: 0,
  //       pageNumber: page || 1,
  //       pageSize: pageSize || 10,
  //     };

  //     const response = await apiService.post("/crop-master/cultivationReport", payload);
  //     if (response.data.status) {
  //       const data = response.data.body.data || [];

  //       if (data.length === 0) {
  //         alert("No data available to export.");
  //         return;
  //       }

  //       const headers = Object.keys(data[0]);
  //       const rows = data.map(item => headers.map(header => item[header]));

  //       const doc = new jsPDF();
  //       doc.text(`Report: ${reportName}`, 10, 10);
  //       doc.text(`Year: ${selectedYear}`, 10, 20);

  //       autoTable(doc, {
  //         head: [headers],
  //         body: rows,
  //         startY: 30,
  //       });

  //       doc.save(`${reportName.replace(/\s+/g, '_')}_${selectedYear}.pdf`);
  //     } else {
  //       alert("Failed to fetch data from API.");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data: ", error);
  //     alert("An error occurred while fetching data.");
  //   }
  // };


  return (
    <div className="container-fluid" style={{ maxHeight: "100vh", overflowX: "auto" }}>      {/* Fixed Year & Season Selection Section */}
      <div className="row mt-3">
        <div className="d-flex align-items-center me-4 p-2 bg-white shadow-sm" style={{ position: "sticky", top: 0, zIndex: 10 }}>

          {/* Year Dropdown */}
          <div className="d-flex align-items-center me-3">
            <div className="me-2 fw-bold">Year</div>
            <select
              className="form-select form-select-sm"
              style={{ width: "100px" }}
              value={year || 0}
              onChange={(e) => {
                setYear(Number(e.target.value));
              }}
            >
              <option value={0} disabled>Select a Year</option>
              {years.map((yr) => (
                <option key={yr.yearId} value={yr.yearValue}>
                  {yr.yearValue}
                </option>
              ))}
            </select>

            {/* Season Dropdown */}
            <div className="d-flex align-items-center">
              {/* <div className="me-2 fw-bold">Season</div>
            <select
              className="form-select form-select-sm"
              style={{ width: "120px" }}
              value={season || ""}
              onChange={(e) => {
                setSeason(Number(e.target.value));  // Storing seasonId
              }}
            >
              <option value="" disabled>Select Season</option>
              {seasons.map((sn) => (
                <option key={sn.seasonId} value={sn.seasonId}>
                  {sn.seasonName}
                </option>
              ))}
            </select> */}
              <Button
                variant="contained"
                color="primary"
                sx={{
                  marginLeft: "20px",
                  padding: "10px 20px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "none",
                  borderRadius: "12px",
                  background: "linear-gradient(90deg, #1976d2, #42a5f5)",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                  "&:hover": {
                    background: "linear-gradient(90deg, #1565c0, #2196f3)",
                  },
                }}
                startIcon={<Download />}
                onClick={handleMenuOpen}
              >
                Export Data
              </Button>

              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem onClick={() => { exportToCSV(year); handleMenuClose(); }}>Download as CSV</MenuItem>
                <MenuItem onClick={() => { exportToXLSX(year); handleMenuClose(); }}>Download as XLSX</MenuItem>
                {/* <MenuItem onClick={() => { exportToPDF(year); handleMenuClose(); }}>Download as PDF</MenuItem> */}
              </Menu>
            </div>

          </div>

        </div></div>
      <div className="row mt-3">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body table-responsive p-0"
              style={{
                minHeight: "60vh",
                overflowX: "auto",
                scrollbarWidth: "thin",
                scrollbarColor: "#ccc transparent",
              }}>
              <table className="table table-hover table-bordered text-nowrap mb-0">
                <thead>
                  <tr>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Village
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={village}
                        onChange={(e) => {
                          setVillage(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      GP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={gp}
                        onChange={(e) => {
                          setGp(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Block
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={block}
                        onChange={(e) => {
                          setBlock(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      District
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={district}
                        onChange={(e) => {
                          setDistrict(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      MIP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={mip}
                        onChange={(e) => {
                          setMip(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Season
                      <br />
                      <select
                        className="form-control form-control-sm"
                        value={selectedSeasonId}
                        onChange={(e) => {
                          setSelectedSeasonId(e.target.value);
                          setPage(1);
                        }}
                      >
                        <option value={0}>All</option>
                        {seasons.map((season) => (
                          <option key={season.seasonId} value={season.seasonId}>
                            {season.seasonName}
                          </option>
                        ))}
                      </select>
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Farmer Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={farmerName}
                        onChange={(e) => {
                          setFarmerName(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Gender
                      <br />
                      <select
                        className="form-control form-control-sm"
                        value={selectedGenderId}
                        onChange={(e) => {
                          setSelectedGenderId(e.target.value);
                          setPage(1);
                        }}
                      >
                        <option value="">All</option>
                        {genders.map((gender) => (
                          <option key={gender.genderId} value={gender.genderId}>
                            {gender.gender}
                          </option>
                        ))}
                      </select>
                    </th>


                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Caste
                      <br />
                      <select
                        className="form-control form-control-sm"
                        value={selectedCasteId || ""}
                        onChange={(e) => {
                          setSelectedCasteId(e.target.value ? Number(e.target.value) : null);
                          setPage(1);
                        }}
                      >
                        <option value="">All</option>
                        {castes.map((caste) => (
                          <option key={caste.casteId} value={caste.casteId}>
                            {caste.caste}
                          </option>
                        ))}
                      </select>
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>PG Code
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={pgcode}
                        onChange={(e) => {
                          setPgCode(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>PG Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={pgName}
                        onChange={(e) => {
                          setPgName(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Seed Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={seedName}
                        onChange={(e) => {
                          setSeedName(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Seed Class
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={seedClass}
                        onChange={(e) => {
                          setSeedClass(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th >
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Seed Variety
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={seedVariety}
                        onChange={(e) => {
                          setSeedVariety(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Crop Type
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={cropType}
                        onChange={(e) => {
                          setCropType(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Culltivation Area
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={cultivatedArea}
                onChange={(e) => {
                  setCultivatedArea(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>

                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Total Planned
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={plannedarea}
                onChange={(e) => {
                  setPlannedarea(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Lease Area
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={plannedarea}
                onChange={(e) => {
                  setPlannedarea(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Planned Area
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={plannedarea}
                onChange={(e) => {
                  setPlannedarea(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>




                  </tr>
                </thead>
                <tbody style={{ fontSize: "14px" }}>
                  {filteredRows.map((data, index) => (
                    <tr key={index}>
                      <td className="py-2">{data.village}</td>
                      <td className="py-2">{data.gp}</td>
                      <td className="py-2">{data.block}</td>
                      <td className="py-2">{data.district}</td>
                      <td className="py-2">{data.mip}</td>
                      <td className="py-2">{data.seasonName}</td>
                      <td className="py-2">{data.farmerName}</td>
                      <td className="py-2">{data.gender}</td>
                      <td className="py-2">{data.caste}</td>
                      <td className="py-2">{data.pgCode}</td>
                      <td className="py-2">{data.pgName}</td>
                      <td className="py-2">{data.seedName}</td>
                      <td className="py-2">{data.seedClass}</td>
                      <td className="py-2">{data.seedVariety}</td>
                      <td className="py-2">{data.cropType}</td>
                      <td className="py-2">{data.cultivatedArea}</td>
                      <td className="py-2">{data.totalPlannedArea}</td>
                      <td className="py-2">{data.leaseArea}</td>
                      <td className="py-2">{data.plannedArea}</td>




                    </tr>
                  ))}
                </tbody>
              </table>
            </div></div></div></div>

      <div className="row mt-3">
        <div className='d-flex justify-content-between pb-0'>
          <div className='p-2'>
            Showing {startItem} to {endItem} of {totalItems} items
          </div>
          <div className='p-2'>
            <Pagination className="mb-0">
              <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
              <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
              {renderPaginationItems()}
              <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalpage} />
              <Pagination.Last onClick={() => handlePageChange(totalpage)} disabled={page === totalpage} />
            </Pagination>
          </div>
        </div>
      </div>

    </div>
  );
};

const CropProduction = ({ reportName }) => {
  const [filteredRows, setFilteredRows] = useState([]);
  const [village, setVillage] = useState("");
  const [gp, setGp] = useState("");
  const [block, setBlock] = useState("");
  const [district, setDistrict] = useState("");
  const [mip, setMip] = useState("");
  const [farmerName, setFarmerName] = useState("");
  const [gender, setGender] = useState("");
  const [caste, setCaste] = useState("");
  const [pgcode, setPgCode] = useState("");
  const [pgName, setPgName] = useState("");
  const [seedName, setSeedName] = useState("");
  const [seedClass, setSeedClass] = useState("");
  const [seedVariety, setSeedVariety] = useState("");
  const [cropType, setCropType] = useState("");
  const [cultivatedArea, setCultivatedArea] = useState("");
  const [page, setPage] = useState(1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [season, setSeason] = useState("");
  const [seasonName, setseasonName] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [totalItems, setTotalitems] = useState(0);
  const [totalpage, setTotalpage] = useState(0);
  const [selectedSeasonId, setSelectedSeasonId] = useState(0);
  const [genders, setGenders] = useState([]);
  const [selectedGenderId, setSelectedGenderId] = useState(0);
  const [castes, setCastes] = useState([]);
  const [selectedCasteId, setSelectedCasteId] = useState(0);
  const [productionquantity, setProductionquantity] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [harvestingdate, setHarvestingdate] = useState("");

  const fetchYears = async () => {
    try {
      const response = await apiService.get("/years/get-all");
      setYears(response.data);
      const currentYear = new Date().getFullYear();
      const defaultYear = response.data.find((yr) => yr.yearValue === currentYear);

      setYear(defaultYear ? defaultYear.yearValue : response.data[0].yearValue);
    } catch (error) {
      console.error("Error fetching years:", error);
    }
  };

  useEffect(() => {

    fetchYears();
  }, []);


  useEffect(() => {
    fetchData();
  }, [farmerName, pgcode, pgName, seedName, cropType, seedClass, seedVariety, village, gp, block, district, mip, cultivatedArea, year,
    selectedSeasonId, selectedGenderId, selectedCasteId, page, productionquantity, harvestingdate]);

  const fetchData = async () => {
    try {
      const payload = {
        seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
        genderId: selectedGenderId ? Number(selectedGenderId) : 0,
        casteId: selectedCasteId ? Number(selectedCasteId) : 0,
        farmerName: farmerName,
        pgCode: pgcode,
        pgName: pgName,
        seedName: seedName,
        cropType: cropType,
        className: seedClass,
        varietyName: seedVariety,
        village: village,
        gpName: gp,
        blockName: block,
        districtName: district,
        mipName: mip,
        year: year,
        cultivatedArea: cultivatedArea ? parseFloat(cultivatedArea) : 0.0,
        productionQuantity: productionquantity ? parseFloat(productionquantity) : 0.0,
        userId: 0,
        pageNumber: page,
        pageSize: 10,
        harvestingDate: harvestingdate || ""
      };




      const response = await apiService.post("/crop-master/getReport", payload);

      if (response.data.status) {
        const data = response.data.body.data || [];
        const totalRecords = response.data.body.recordsCount || 0;
        const totalPages = pageSize > 0 ? Math.ceil(totalRecords / pageSize) : 0;

        setFilteredRows(data);
        setTotalitems(totalRecords);
        setTotalpage(totalPages);
        setRows(data);
        setRowCount(totalRecords);
      } else {
        setFilteredRows([]);
        setTotalitems(0);
        setTotalpage(0);
        setRows([]);
        setRowCount(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };



  const fetchSeasons = async () => {
    try {
      const response = await apiService.get("/seasons/get-all");
      setSeasons(response.data);
    } catch (error) {
      console.error("Error fetching seasons:", error);
    }
  };

  const fetchGenders = async () => {
    try {
      const response = await apiService.get("/master/get-all-gender");
      setGenders(response.data || []);
    } catch (error) {
      console.error("Error fetching genders:", error);
    }
  };
  const fetchCastes = async () => {
    try {
      const response = await apiService.get("/castes/get-all");
      setCastes(response.data);
    } catch (error) {
      console.error("Error fetching castes:", error);
    }
  };
  useEffect(() => {

    fetchYears();
    fetchSeasons();
    fetchGenders();
    fetchCastes();
  }, []);



  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const startItem = (page - 1) * 10 + 1;
  const endItem = Math.min(page * 10, totalItems);

  const renderPaginationItems = () => {
    const paginationItems = [];
    const maxPagesToShow = 7;
    const startPages = 3;
    const endPages = 2;

    if (totalpage <= maxPagesToShow) {
      for (let pages = 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    } else {
      // Show first 3 pages
      for (let pages = 1; pages <= startPages; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      // Show ellipsis if necessary
      if (page > startPages + 1) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }

      // Show the middle pages around the current page
      const middlePages = [];
      const startMiddlePage = Math.max(page - 1, startPages + 1);
      const endMiddlePage = Math.min(page + 1, totalpage - endPages);

      for (let pages = startMiddlePage; pages <= endMiddlePage; pages++) {
        middlePages.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      paginationItems.push(...middlePages);

      // Show ellipsis if necessary
      if (page < totalpage - endPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      // Show last 2 pages
      for (let pages = totalpage - endPages + 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    }
    return paginationItems;
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const exportToCSV = async (selectedYear) => {
    try {
      const payload = {
        seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
        casteId: selectedCasteId ? Number(selectedCasteId) : 0,
        genderId: selectedGenderId ? Number(selectedGenderId) : 0,
        farmerName: farmerName || "",
        pgCode: pgcode || "",
        pgName: pgName || "",
        seedName: seedName || "",
        cropType: cropType || "",
        className: seedClass || "",
        varietyName: seedVariety || "",
        villageName: village || "",
        gpName: gp || "",
        blockName: block || "",
        districtName: district || "",
        mipName: mip || "",
        year: year ? Number(year) : null,
        productionquantity: productionquantity || "",
        userId: 0,
        pageNumber: page || 1,
        pageSize: pageSize || 10,
        harvestingDate: harvestingdate || ""
      };

      const response = await apiService.post("/crop-master/getReport", payload);

      if (response.data.status) {
        const data = response.data.body.data || [];

        if (data.length === 0) {
          alert("No data available to export.");
          return;
        }

        // Define headers in required order
        const headers = [
          "Village", "GP", "Block", "District", "MIP", "Season", "Gender",
          "Farmer Name", "Caste", "PG Code", "PG Name",
          "Seed Name", "Seed Class", "Seed Variety", "Crop Type", "Cultivated Area", "production Qty", "Harvesting Date"
        ];

        // Map data to match the header order
        const rows = data.map(item => [
          item.village ?? "",
          item.gp ?? "",
          item.block ?? "",
          item.district ?? "",
          item.mip ?? "",
          item.seasonName ?? "",
          item.gender ?? "",
          item.farmerName ?? "",
          item.caste ?? "",
          item.pgCode ?? "",
          item.pgName ?? "",
          item.seedName ?? "",
          item.seedClass ?? "",
          item.seedVariety ?? "",
          item.cropType ?? "",
          item.cultivatedArea ?? "",
          item.productionQuantity ?? "",
          item.harvestingDate ? format(parseISO(item.harvestingDate), "dd-MM-yyyy") : "N/A"
        ]);

        // Convert array to CSV format
        const csvContent = [
          `Report: ${reportName}`,
          `Year: ${selectedYear}`,
          headers.join(","),
          ...rows.map(row => row.map(value => `"${value}"`).join(",")) // Ensure values with commas are wrapped in quotes
        ].join("\n");

        // Create and download CSV file
        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${reportName.replace(/\s+/g, '_')}_${selectedYear}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        alert("Failed to fetch data from API.");
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      alert("An error occurred while fetching data.");
    }
  };

  const exportToXLSX = async (selectedYear) => {
    try {
      const payload = {
        seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
        casteId: selectedCasteId ? Number(selectedCasteId) : 0,
        genderId: selectedGenderId ? Number(selectedGenderId) : 0,
        farmerName: farmerName || "",
        pgCode: pgcode || "",
        pgName: pgName || "",
        seedName: seedName || "",
        cropType: cropType || "",
        className: seedClass || "",
        varietyName: seedVariety || "",
        villageName: village || "",
        gpName: gp || "",
        blockName: block || "",
        districtName: district || "",
        mipName: mip || "",
        year: year ? Number(year) : null,
        productionquantity: productionquantity || "",
        userId: 0,
        pageNumber: page || 1,
        pageSize: pageSize || 10,
        harvestingDate: harvestingdate || ""
      };

      const response = await apiService.post("/crop-master/getReport", payload);

      if (response.data.status) {
        const data = response.data.body.data || [];

        if (data.length === 0) {
          alert("No data available to export.");
          return;
        }

        // Define headers
        const headers = [
          "Village", "GP", "Block", "District", "MIP", "Season",
          "Farmer Name", "Gender", "Caste", "PG Code", "PG Name",
          "Seed Name", "Seed Class", "Seed Variety", "Crop Type", "Cultivated Area", "Production Qty", "Harvesting Date"
        ];

        // Map data to match headers
        const rows = data.map(item => [
          item.village ?? "",
          item.gp ?? "",
          item.block ?? "",
          item.district ?? "",
          item.mip ?? "",
          item.seasonName ?? "",
          item.farmerName ?? "",
          item.gender ?? "",
          item.caste ?? "",
          item.pgCode ?? "",
          item.pgName ?? "",
          item.seedName ?? "",
          item.seedClass ?? "",
          item.seedVariety ?? "",
          item.cropType ?? "",
          item.cultivatedArea ?? "",
          item.productionQuantity ?? "",
          item.harvestingDate ? format(parseISO(item.harvestingDate), "dd-MM-yyyy") : "N/A"
        ]);

        // Create worksheet
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Generate and download file
        const fileName = `CropProduction_Report_${selectedYear}.xlsx`;
        XLSX.writeFile(workbook, fileName);
      } else {
        alert("Failed to fetch data from API.");
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      alert("An error occurred while fetching data.");
    }
  };

  // const exportToPDF = async (selectedYear) => {
  //   try {
  //     const payload = {
  //       seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
  //       casteId: selectedCasteId ? Number(selectedCasteId) : 0,
  //       genderId: selectedGenderId ? Number(selectedGenderId) : 0,
  //       farmerName: farmerName || "",
  //       pgCode: pgcode || "",
  //       pgName: pgName || "",
  //       seedName: seedName || "",
  //       cropType: cropType || "",
  //       className: seedClass || "",
  //       varietyName: seedVariety || "",
  //       villageName: village || "",
  //       gpName: gp || "",
  //       blockName: block || "",
  //       districtName: district || "",
  //       mipName: mip || "",
  //       year: year ? Number(year) : null,
  //       productionquantity: productionquantity || "",
  //       userId: 0,
  //       pageNumber: page || 1,
  //       pageSize: pageSize || 10,
  //     };

  //     const response = await apiService.post("/crop-master/getReport", payload);
  //     if (response.data.status) {
  //       const data = response.data.body.data || [];

  //       if (data.length === 0) {
  //         alert("No data available to export.");
  //         return;
  //       }

  //       const headers = Object.keys(data[0]);
  //       const rows = data.map(item => headers.map(header => item[header]));

  //       const doc = new jsPDF();
  //       doc.text(`Report: ${reportName}`, 10, 10);
  //       doc.text(`Year: ${selectedYear}`, 10, 20);

  //       autoTable(doc, {
  //         head: [headers],
  //         body: rows,
  //         startY: 30,
  //       });

  //       doc.save(`${reportName.replace(/\s+/g, '_')}_${selectedYear}.pdf`);
  //     } else {
  //       alert("Failed to fetch data from API.");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data: ", error);
  //     alert("An error occurred while fetching data.");
  //   }
  // };



  return (
    <div className="container-fluid" style={{ maxHeight: "100vh", overflowX: "auto" }}>
      <div className="row mt-3">
        <div className="d-flex align-items-center me-4 p-2 bg-white shadow-sm"
          style={{ position: "sticky", top: 0, zIndex: 10 }}>

          {/* Year Dropdown */}
          <div className="d-flex align-items-center me-3">
            <div className="me-2 fw-bold">Year</div>
            <select
              className="form-select form-select-sm"
              style={{ width: "100px" }}
              value={year || 0}
              onChange={(e) => {
                setYear(Number(e.target.value));
              }}
            >
              <option value={0} disabled>Select a Year</option>
              {years.map((yr) => (
                <option key={yr.yearId} value={yr.yearValue}>
                  {yr.yearValue}
                </option>
              ))}
            </select>


            {/* Season Dropdown */}
            <div className="d-flex align-items-center">
              {/* <div className="me-2 fw-bold">Season</div>
            <select
              className="form-select form-select-sm"
              style={{ width: "120px" }}
              value={season || ""}
              onChange={(e) => {
                setSeason(Number(e.target.value));  // Storing seasonId
              }}
            >
              <option value="" disabled>Select Season</option>
              {seasons.map((sn) => (
                <option key={sn.seasonId} value={sn.seasonId}>
                  {sn.seasonName}
                </option>
              ))}
            </select> */}
              <Button
                variant="contained"
                color="primary"
                sx={{
                  marginLeft: "20px",
                  padding: "10px 20px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "none",
                  borderRadius: "12px",
                  background: "linear-gradient(90deg, #1976d2, #42a5f5)",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                  "&:hover": {
                    background: "linear-gradient(90deg, #1565c0, #2196f3)",
                  },
                }}
                startIcon={<Download />}
                onClick={handleMenuOpen}
              >
                Export Data
              </Button>

              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem onClick={() => { exportToCSV(year); handleMenuClose(); }}>Download as CSV</MenuItem>
                <MenuItem onClick={() => { exportToXLSX(year); handleMenuClose(); }}>Download as XLSX</MenuItem>
                {/* <MenuItem onClick={() => { exportToPDF(year); handleMenuClose(); }}>Download as PDF</MenuItem> */}
              </Menu>
            </div>

          </div>

        </div></div>

      <div className="row mt-3">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body table-responsive p-0"
              style={{
                minHeight: "60vh",
                overflowX: "auto",
                scrollbarWidth: "thin",
                scrollbarColor: "#ccc transparent",
              }}>
              <table className="table table-hover table-bordered text-nowrap mb-0">
                <thead style={{ whiteSpace: "nowrap" }}>
                  <tr>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Village
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={village}
                        onChange={(e) => {
                          setVillage(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      GP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={gp}
                        onChange={(e) => {
                          setGp(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Block
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={block}
                        onChange={(e) => {
                          setBlock(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      District
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={district}
                        onChange={(e) => {
                          setDistrict(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      MIP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={mip}
                        onChange={(e) => {
                          setMip(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Season
                      <br />
                      <select
                        className="form-control form-control-sm"
                        value={selectedSeasonId}
                        onChange={(e) => {
                          setSelectedSeasonId(e.target.value);
                          setPage(1);
                        }}
                      >
                        <option value={0}>All</option>
                        {seasons.map((season) => (
                          <option key={season.seasonId} value={season.seasonId}>
                            {season.seasonName}
                          </option>
                        ))}
                      </select>
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Farmer Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={farmerName}
                        onChange={(e) => {
                          setFarmerName(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Gender
                      <br />
                      <select
                        className="form-control form-control-sm"
                        value={selectedGenderId}
                        onChange={(e) => {
                          setSelectedGenderId(e.target.value);
                          setPage(1);
                        }}
                      >
                        <option value="">All</option>
                        {genders.map((gender) => (
                          <option key={gender.genderId} value={gender.genderId}>
                            {gender.gender}
                          </option>
                        ))}
                      </select>
                    </th>

                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Caste
                      <br />
                      <select
                        className="form-control form-control-sm"
                        value={selectedCasteId || ""}
                        onChange={(e) => {
                          setSelectedCasteId(e.target.value ? Number(e.target.value) : null);
                          setPage(1);
                        }}
                      >
                        <option value="">All</option>
                        {castes.map((caste) => (
                          <option key={caste.casteId} value={caste.casteId}>
                            {caste.caste}
                          </option>
                        ))}
                      </select>
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>PG Code
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={pgcode}
                        onChange={(e) => {
                          setPgCode(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>PG Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={pgName}
                        onChange={(e) => {
                          setPgName(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Seed Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={seedName}
                        onChange={(e) => {
                          setSeedName(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Seed Class
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={seedClass}
                        onChange={(e) => {
                          setSeedClass(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Seed Variety
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={seedVariety}
                        onChange={(e) => {
                          setSeedVariety(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Crop Type
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={cropType}
                        onChange={(e) => {
                          setCropType(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Culltivation Area
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={cultivatedArea}
                onChange={(e) => {
                  setCultivatedArea(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>

                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Production Qty
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={productionquantity}
                onChange={(e) => {
                  setProductionquantity(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>





                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Harvestingdate
                      <br />
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={harvestingdate}
                        onChange={(e) => {
                          setHarvestingdate(e.target.value);
                        }}
                      />
                    </th>



                  </tr>
                </thead>
                <tbody style={{ fontSize: "14px" }}>
                  {filteredRows.map((data, index) => (
                    <tr key={index}>
                      <td className="py-2">{data.village}</td>
                      <td className="py-2">{data.gp}</td>
                      <td className="py-2">{data.block}</td>
                      <td className="py-2">{data.district}</td>
                      <td className="py-2">{data.mip}</td>
                      <td className="py-2">{data.seasonName}</td>
                      <td className="py-2">{data.farmerName}</td>
                      <td className="py-2">{data.gender}</td>
                      <td className="py-2">{data.caste}</td>
                      <td className="py-2">{data.pgCode}</td>
                      <td className="py-2">{data.pgName}</td>
                      <td className="py-2">{data.seedName}</td>
                      <td className="py-2">{data.seedClass}</td>
                      <td className="py-2">{data.seedVariety}</td>
                      <td className="py-2">{data.cropType}</td>
                      <td className="py-2">{data.cultivatedArea}</td>
                      <td className="py-2">{data.productionQuantity}</td>
                      <td className="py-2">{data.harvestingDate ? format(parseISO(data.harvestingDate), "dd-MM-yyyy") : "N/A"}</td>



                    </tr>
                  ))}
                </tbody>
              </table>
            </div></div></div></div>

      <div className="row mt-3">
        <div className='d-flex justify-content-between pb-0'>
          <div className='p-2'>
            Showing {startItem} to {endItem} of {totalItems} items
          </div>
          <div className='p-2'>
            <Pagination className="mb-0">
              <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
              <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
              {renderPaginationItems()}
              <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalpage} />
              <Pagination.Last onClick={() => handlePageChange(totalpage)} disabled={page === totalpage} />
            </Pagination>
          </div>
        </div>
      </div>

    </div>
  );
};

const Marketlinkage = ({ reportName }) => {
  const [filteredRows, setFilteredRows] = useState([]);
  const [village, setVillage] = useState("");
  const [gp, setGp] = useState("");
  const [block, setBlock] = useState("");
  const [district, setDistrict] = useState("");
  const [mip, setMip] = useState("");
  const [season, setSeason] = useState("");
  const [farmername, setFarmerName] = useState("");
  const [gender, setGender] = useState("");
  const [caste, setCaste] = useState("");
  const [pgcode, setPgCode] = useState("");
  const [pgName, setPgName] = useState("");
  const [seedName, setSeedName] = useState("");
  const [seedClass, setSeedClass] = useState("");
  const [seedVariety, setSeedVariety] = useState("");
  const [cropType, setCropType] = useState("");
  const [culltivationarea, setCulltivationarea] = useState("");
  const [productionquantity, setProductionquantity] = useState("");
  const [baseprice, setBaseprice] = useState("");
  const [saleprice, setSaleprice] = useState("");
  const [saleqty, setSaleqty] = useState("");
  const [addincome, setAddincome] = useState("");
  const [tlseed, settlseed] = useState("");
  const [consumption, setConsumption] = useState("");

  const [page, setPage] = useState(1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [totalItems, setTotalitems] = useState(0);
  const [totalpage, setTotalpage] = useState(0);
  const [saletype, setSaletype] = useState("");
  const [location, setLocation] = useState("");


  const [cultivatedArea, setCultivatedArea] = useState("");

  const [seasonName, setseasonName] = useState('');

  const [selectedSeasonId, setSelectedSeasonId] = useState(0);
  const [genders, setGenders] = useState([]);
  const [selectedGenderId, setSelectedGenderId] = useState(0);
  const [castes, setCastes] = useState([]);
  const [selectedCasteId, setSelectedCasteId] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);


  const fetchYears = async () => {
    try {
      const response = await apiService.get("/years/get-all");
      setYears(response.data);
      const currentYear = new Date().getFullYear();
      const defaultYear = response.data.find((yr) => yr.yearValue === currentYear);

      setYear(defaultYear ? defaultYear.yearValue : response.data[0].yearValue);
    } catch (error) {
      console.error("Error fetching years:", error);
    }
  };


  useEffect(() => {

    fetchYears();
  }, []);




  useEffect(() => {
    fetchData();
  }, [village, page, gp, block, district, mip, season, farmername, gender, caste, pgcode, pgName, seedName, seedClass, seedVariety, cropType, culltivationarea, productionquantity, baseprice,
    saleprice, saleqty, addincome, tlseed, consumption, year, seasonName, selectedSeasonId, selectedGenderId, selectedCasteId, pageSize, page, saletype, location]);

  const fetchData = async () => {
    try {
      const payload = {
        seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
        genderId: selectedGenderId ? Number(selectedGenderId) : 0,
        casteId: selectedCasteId ? Number(selectedCasteId) : 0,
        farmerName: farmername || "",
        pgCode: pgcode || "",
        pgName: pgName || "",
        villageName: village || "",
        gpName: gp || "",
        blockName: block || "",
        districtName: district || "",
        mipName: mip || "",
        year: year ? Number(year) : 0,
        seedName: seedName || "",
        cropType: cropType || "",
        className: seedClass || "",
        varietyName: seedVariety || "",
        salePrice: saleprice ? parseFloat(saleprice) : null,
        basePrice: baseprice ? parseFloat(baseprice) : null,
        tlSeed: tlseed ? parseFloat(tlseed) : null,
        consumption: consumption ? parseFloat(consumption) : null,
        sellQuantity: saleqty ? parseFloat(saleqty) : null,
        plannedArea: null,
        cultivatedArea: culltivationarea ? parseFloat(culltivationarea) : null,
        totalProduction: null,
        productionquantity: productionquantity ? parseFloat(productionquantity) : null,
        additionalIncome: addincome ? parseFloat(addincome) : null,
        userId: 0,
        pageSize: 10,
        pageNumber: page || 1,
        saleType: saletype || "",
        location: location || "",
      };

      const response = await apiService.post("/market-linkage/getReport", payload);

      if (response.data.status) {
        const data = response.data.body.data || [];
        const totalRecords = response.data.body.recordsCount || 0;
        const totalPages = payload.pageSize > 0 ? Math.ceil(totalRecords / payload.pageSize) : 0;

        setFilteredRows(data);
        setTotalitems(totalRecords);
        setTotalpage(totalPages);
        setRows(data);
        setRowCount(totalRecords);
      } else {
        setFilteredRows([]);
        setTotalitems(0);
        setTotalpage(0);
        setRows([]);
        setRowCount(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };




  const fetchSeasons = async () => {
    try {
      const response = await apiService.get("/seasons/get-all");
      setSeasons(response.data);
    } catch (error) {
      console.error("Error fetching seasons:", error);
    }
  };

  const fetchGenders = async () => {
    try {
      const response = await apiService.get("/master/get-all-gender");
      setGenders(response.data || []);
    } catch (error) {
      console.error("Error fetching genders:", error);
    }
  };
  const fetchCastes = async () => {
    try {
      const response = await apiService.get("/castes/get-all");
      setCastes(response.data);
    } catch (error) {
      console.error("Error fetching castes:", error);
    }
  };
  useEffect(() => {

    fetchYears();
    fetchSeasons();
    fetchGenders();
    fetchCastes();
  }, []);




  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const startItem = (page - 1) * 10 + 1;
  const endItem = Math.min(page * 10, totalItems);

  const renderPaginationItems = () => {
    const paginationItems = [];
    const maxPagesToShow = 7;
    const startPages = 3;
    const endPages = 2;

    if (totalpage <= maxPagesToShow) {
      for (let pages = 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    } else {
      // Show first 3 pages
      for (let pages = 1; pages <= startPages; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      // Show ellipsis if necessary
      if (page > startPages + 1) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }

      // Show the middle pages around the current page
      const middlePages = [];
      const startMiddlePage = Math.max(page - 1, startPages + 1);
      const endMiddlePage = Math.min(page + 1, totalpage - endPages);

      for (let pages = startMiddlePage; pages <= endMiddlePage; pages++) {
        middlePages.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      paginationItems.push(...middlePages);

      // Show ellipsis if necessary
      if (page < totalpage - endPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      // Show last 2 pages
      for (let pages = totalpage - endPages + 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    }
    return paginationItems;
  };


  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const exportToCSV = async (selectedYear) => {
    try {
      const payload = {
        seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
        genderId: selectedGenderId ? Number(selectedGenderId) : 0,
        casteId: selectedCasteId ? Number(selectedCasteId) : 0,
        farmerName: farmername || "",
        pgCode: pgcode || "",
        pgName: pgName || "",
        villageName: village || "",
        gpName: gp || "",
        blockName: block || "",
        districtName: district || "",
        mipName: mip || "",
        year: year ? Number(year) : 0,
        seedName: seedName || "",
        cropType: cropType || "",
        className: seedClass || "",
        varietyName: seedVariety || "",
        salePrice: null,
        basePrice: null,
        tlSeed: null,
        consumption: null,
        sellQuantity: null,
        plannedArea: null,
        cultivatedArea: cultivatedArea ? parseFloat(cultivatedArea) : null,
        totalProduction: null,
        additionalIncome: null,
        userId: 0,
        pageSize: 10,
        pageNumber: page || 1,
        saleType: saletype || "",
        location: location || "",
      };

      const response = await apiService.post("/market-linkage/getReport", payload);

      if (response.data.status) {
        const data = response.data.body.data || [];

        if (data.length === 0) {
          alert("No data available to export.");
          return;
        }

        const headers = [
          "Village", "GP", "Block", "District", "MIP", "Season", "Gender",
          "Farmer Name", "Caste", "PG Code", "PG Name",
          "Seed Name", "Seed Class", "Seed Variety", "Crop Type", "Cultivated Area", "production Qty", "Base Price", "Sale Price", "SaleType", "location", "TL Seed", "Consumption", "Sell Quantity", "Planned Area", "Additional Income"
        ];

        const rows = data.map(item => [
          item.villageName ?? "",
          item.gpName ?? "",
          item.blockName ?? "",
          item.districtName ?? "",
          item.mipName ?? "",
          item.seasonName ?? "",
          item.gender ?? "",
          item.farmerName ?? "",
          item.caste ?? "",
          item.pgCode ?? "",
          item.pgName ?? "",
          item.seedName ?? "",
          item.seedClass ?? "",
          item.seedVariety ?? "",
          item.cropType ?? "",
          item.cultivatedArea ?? "",
          item.totalProduction ?? "", // Fixed mapping
          item.basePrice ?? "",
          item.salePrice ?? "",
          item.saleType ?? "",
          item.location ?? "",
          item.tlSeed ?? "",

          item.consumption ?? "",
          item.sellQuantity ?? "",
          item.plannedArea ?? "",
          item.additionalIncome ?? "",

        ]);

        const csvContent = [
          `Report: ${reportName}`,
          `Year: ${selectedYear}`,
          headers.join(","),
          ...rows.map(row => row.map(value => `"${value}"`).join(","))
        ].join("\n");

        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${reportName.replace(/\s+/g, '_')}_${selectedYear}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        alert("Failed to fetch data from API.");
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      alert("An error occurred while fetching data.");
    }
  };

  const exportToXLSX = async (selectedYear) => {
    try {
      const payload = {
        seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
        genderId: selectedGenderId ? Number(selectedGenderId) : 0,
        casteId: selectedCasteId ? Number(selectedCasteId) : 0,
        farmerName: farmername || "",
        pgCode: pgcode || "",
        pgName: pgName || "",
        villageName: village || "",
        gpName: gp || "",
        blockName: block || "",
        districtName: district || "",
        mipName: mip || "",
        year: year ? Number(year) : 0,
        seedName: seedName || "",
        cropType: cropType || "",
        className: seedClass || "",
        varietyName: seedVariety || "",
        salePrice: null,
        basePrice: null,
        tlSeed: null,
        consumption: null,
        sellQuantity: null,
        plannedArea: null,
        cultivatedArea: cultivatedArea ? parseFloat(cultivatedArea) : null,
        totalProduction: null,
        additionalIncome: null,
        userId: 0,
        pageSize: 10,
        pageNumber: page || 1,
        saleType: saletype || "",
        location: location || "",

      };

      const response = await apiService.post("/market-linkage/getReport", payload);

      if (response.data.status) {
        const data = response.data.body.data || [];

        if (data.length === 0) {
          alert("No data available to export.");
          return;
        }

        // Define headers
        const headers = [
          "Village", "GP", "Block", "District", "MIP", "Season", "Gender",
          "Farmer Name", "Caste", "PG Code", "PG Name",
          "Seed Name", "Seed Class", "Seed Variety", "Crop Type", "Cultivated Area", "production Qty", "Base Price", "Sale Price", "Sale Type", "Location", "TL Seed", "Consumption", "Sell Quantity", "Planned Area", "Additional Income"

        ];

        // Map data to match headers
        const rows = data.map(item => [
          item.villageName ?? "",
          item.gpName ?? "",
          item.blockName ?? "",
          item.districtName ?? "",
          item.mipName ?? "",
          item.seasonName ?? "",
          item.gender ?? "",
          item.farmerName ?? "",
          item.caste ?? "",
          item.pgCode ?? "",
          item.pgName ?? "",
          item.seedName ?? "",
          item.seedClass ?? "",
          item.seedVariety ?? "",
          item.cropType ?? "",
          item.cultivatedArea ?? "",
          item.totalProduction ?? "", // Fixed mapping
          item.basePrice ?? "",
          item.salePrice ?? "",
          item.saleType ?? "",
          item.location ?? "",
          item.tlSeed ?? "",

          item.consumption ?? "",
          item.sellQuantity ?? "",
          item.plannedArea ?? "",
          item.additionalIncome ?? "",

        ]);

        // Create worksheet
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Generate and download file
        const fileName = `Marketlinkage_Report_${selectedYear}.xlsx`;
        XLSX.writeFile(workbook, fileName);
      } else {
        alert("Failed to fetch data from API.");
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      alert("An error occurred while fetching data.");
    }
  };

  // const exportToPDF = async (selectedYear) => {
  //   try {
  //     const payload = {
  //       seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
  //       genderId: selectedGenderId ? Number(selectedGenderId) : 0,
  //       casteId: selectedCasteId ? Number(selectedCasteId) : 0,
  //       farmerName: farmername || "",
  //       pgCode: pgcode || "",
  //       pgName: pgName || "",
  //       villageName: village || "",
  //       gpName: gp || "",
  //       blockName: block || "",
  //       districtName: district || "",
  //       mipName: mip || "",
  //       year: year ? Number(year) : 0,
  //       seedName: seedName || "",
  //       cropType: cropType || "",
  //       className: seedClass || "",
  //       varietyName: seedVariety || "",
  //       salePrice: null,
  //       basePrice: null,
  //       tlSeed: null,
  //       consumption: 2,
  //       sellQuantity: null,
  //       plannedArea: null,
  //       cultivatedArea: cultivatedArea ? parseFloat(cultivatedArea) : null,
  //       totalProduction: null,
  //       additionalIncome: null,
  //       userId: 0,
  //       pageSize: 10,
  //       pageNumber: page || 1,

  //     };

  //     const response = await apiService.post("/market-linkage/getReport", payload);
  //     if (response.data.status) {
  //       const data = response.data.body.data || [];

  //       if (data.length === 0) {
  //         alert("No data available to export.");
  //         return;
  //       }

  //       const headers = Object.keys(data[0]);
  //       const rows = data.map(item => headers.map(header => item[header]));

  //       const doc = new jsPDF();
  //       doc.text(`Report: ${reportName}`, 10, 10);
  //       doc.text(`Year: ${selectedYear}`, 10, 20);

  //       autoTable(doc, {
  //         head: [headers],
  //         body: rows,
  //         startY: 30,
  //       });

  //       doc.save(`${reportName.replace(/\s+/g, '_')}_${selectedYear}.pdf`);
  //     } else {
  //       alert("Failed to fetch data from API.");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data: ", error);
  //     alert("An error occurred while fetching data.");
  //   }
  // };

  return (
    <div className="container-fluid" style={{ maxHeight: "100vh", overflowX: "auto" }}>      {/* Fixed Year & Season Selection Section */}
      <div className="row mt-3">
        <div className="d-flex align-items-center me-4 p-2 bg-white shadow-sm"
          style={{ position: "sticky", top: 0, zIndex: 10 }}>

          {/* Year Dropdown */}
          <div className="d-flex align-items-center me-3">
            <div className="me-2 fw-bold">Year</div>
            <select
              className="form-select form-select-sm"
              style={{ width: "100px" }}
              value={year || 0}
              onChange={(e) => {
                setYear(Number(e.target.value));
              }}
            >
              <option value={0} disabled>Select a Year</option>
              {years.map((yr) => (
                <option key={yr.yearId} value={yr.yearValue}>
                  {yr.yearValue}
                </option>
              ))}
            </select>

            {/* Season Dropdown */}
            <div className="d-flex align-items-center">
              {/* <div className="me-2 fw-bold">Season</div>
            <select
              className="form-select form-select-sm"
              style={{ width: "120px" }}
              value={season || ""}
              onChange={(e) => {
                setSeason(Number(e.target.value));  // Storing seasonId
              }}
            >
              <option value="" disabled>Select Season</option>
              {seasons.map((sn) => (
                <option key={sn.seasonId} value={sn.seasonId}>
                  {sn.seasonName}
                </option>
              ))}
            </select> */}
              <Button
                variant="contained"
                color="primary"
                sx={{
                  marginLeft: "20px",
                  padding: "10px 20px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "none",
                  borderRadius: "12px",
                  background: "linear-gradient(90deg, #1976d2, #42a5f5)",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                  "&:hover": {
                    background: "linear-gradient(90deg, #1565c0, #2196f3)",
                  },
                }}
                startIcon={<Download />}
                onClick={handleMenuOpen}
              >
                Export Data
              </Button>

              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem onClick={() => { exportToCSV(year); handleMenuClose(); }}>Download as CSV</MenuItem>
                <MenuItem onClick={() => { exportToXLSX(year); handleMenuClose(); }}>Download as XLSX</MenuItem>
                {/* <MenuItem onClick={() => { exportToPDF(year); handleMenuClose(); }}>Download as PDF</MenuItem> */}
              </Menu>
            </div>

          </div>

        </div></div>
      <div className="row mt-3">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body table-responsive p-0"
              style={{
                minHeight: "60vh",
                overflowX: "auto",
                scrollbarWidth: "thin",
                scrollbarColor: "#ccc transparent",
              }}>
              <table className="table table-hover table-bordered text-nowrap mb-0">
                <thead>
                  <tr>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Village
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={village}
                        onChange={(e) => {
                          setVillage(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      GP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={gp}
                        onChange={(e) => {
                          setGp(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Block
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={block}
                        onChange={(e) => {
                          setBlock(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      District
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={district}
                        onChange={(e) => {
                          setDistrict(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      MIP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={mip}
                        onChange={(e) => {
                          setMip(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Season
                      <br />
                      <select
                        className="form-control form-control-sm"
                        value={selectedSeasonId}
                        onChange={(e) => {
                          setSelectedSeasonId(e.target.value);
                          setPage(1);
                        }}
                      >
                        <option value={0}>All</option>
                        {seasons.map((season) => (
                          <option key={season.seasonId} value={season.seasonId}>
                            {season.seasonName}
                          </option>
                        ))}
                      </select>
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Farmer Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={farmername}
                        onChange={(e) => {
                          setFarmerName(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Gender
                      <br />
                      <select
                        className="form-control form-control-sm"
                        value={selectedGenderId}
                        onChange={(e) => {
                          setSelectedGenderId(e.target.value);
                          setPage(1);
                        }}
                      >
                        <option value="">All</option>
                        {genders.map((gender) => (
                          <option key={gender.genderId} value={gender.genderId}>
                            {gender.gender}
                          </option>
                        ))}
                      </select>
                    </th>

                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>
                      Caste
                      <br />
                      <select
                        className="form-control form-control-sm"
                        value={selectedCasteId || ""}
                        onChange={(e) => {
                          setSelectedCasteId(e.target.value ? Number(e.target.value) : null);
                          setPage(1);
                        }}
                      >
                        <option value="">All</option>
                        {castes.map((caste) => (
                          <option key={caste.casteId} value={caste.casteId}>
                            {caste.caste}
                          </option>
                        ))}
                      </select>
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>PG Code
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={pgcode}
                        onChange={(e) => {
                          setPgCode(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>PG Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={pgName}
                        onChange={(e) => {
                          setPgName(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Seed Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={seedName}
                        onChange={(e) => {
                          setSeedName(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Seed Class
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={seedClass}
                        onChange={(e) => {
                          setSeedClass(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Seed Variety
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={seedVariety}
                        onChange={(e) => {
                          setSeedVariety(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Crop Type
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={cropType}
                        onChange={(e) => {
                          setCropType(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Culltivation Area
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={culltivationarea}
                onChange={(e) => {
                  setCulltivationarea(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Production Qty
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={productionquantity}
                onChange={(e) => {
                  setProductionquantity(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Sale Qty
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={saleqty}
                onChange={(e) => {
                  setSaleqty(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Base Price
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={baseprice}
                onChange={(e) => {
                  setBaseprice(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Sale Price
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={saleprice}
                onChange={(e) => {
                  setSaleprice(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>

                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Add. Income
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={addincome}
                onChange={(e) => {
                  setAddincome(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>

                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Sale Type
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={saletype}
                        onChange={(e) => {
                          setSaletype(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Location
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={location}
                        onChange={(e) => {
                          setLocation(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>

                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Tlseed
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={tlseed}
                onChange={(e) => {
                  settlseed(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>




                    <th className="py-2 align-middle" style={{ minWidth: "100px" }}>Consumption
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={consumption}
                onChange={(e) => {
                  setConsumption(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>


                  </tr>
                </thead>
                <tbody style={{ fontSize: "14px" }}>
                  {filteredRows.map((data, index) => (
                    <tr key={index}>
                      <td className="py-2">{data.villageName}</td>
                      <td className="py-2">{data.gpName}</td>
                      <td className="py-2">{data.blockName}</td>
                      <td className="py-2">{data.districtName}</td>
                      <td className="py-2">{data.mipName}</td>
                      <td className="py-2">{data.seasonName}</td>
                      <td className="py-2">{data.farmerName}</td>
                      <td className="py-2">{data.gender}</td>
                      <td className="py-2">{data.caste}</td>
                      <td className="py-2">{data.pgCode}</td>
                      <td className="py-2">{data.pgName}</td>
                      <td className="py-2">{data.seedName}</td>
                      <td className="py-2">{data.seedClass}</td>
                      <td className="py-2">{data.seedVariety}</td>
                      <td className="py-2">{data.cropType}</td>
                      <td className="py-2">{data.cultivatedArea}</td>
                      <td className="py-2">{data.totalProduction}</td>
                      <td className="py-2">{data.sellQuantity}</td>

                      <td className="py-2">{data.basePrice}</td>
                      <td className="py-2">{data.salePrice}</td>

                      <td className="py-2">{data.additionalIncome}</td>
                      <td classNmae="py-2">{data.saleType}</td>
                      <td className="py-2">{data.location}</td>
                      <td className="py-2">{data.tlSeed}</td>

                      <td className="py-2">{data.consumption}</td>


                    </tr>
                  ))}
                </tbody>
              </table>
            </div></div></div></div>
      <div className="row mt-3">
        <div className='d-flex justify-content-between pb-0'>
          <div className='p-2'>
            Showing {startItem} to {endItem} of {totalItems} items
          </div>
          <div className='p-2'>
            <Pagination className="mb-0">
              <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
              <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
              {renderPaginationItems()}
              <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalpage} />
              <Pagination.Last onClick={() => handlePageChange(totalpage)} disabled={page === totalpage} />
            </Pagination>
          </div>
        </div>
      </div>

    </div>
  );
};

const Productioncroparea = ({ reportName }) => {
  const [filteredRows, setFilteredRows] = useState([]);
  const [village, setVillage] = useState("");
  const [gp, setGp] = useState("");
  const [block, setBlock] = useState("");
  const [district, setDistrict] = useState("");
  const [mip, setMip] = useState("");
  const [season, setSeason] = useState("");
  const [farmername, setFarmerName] = useState("");
  const [gender, setGender] = useState("");
  const [caste, setCaste] = useState("");
  const [pgcode, setPgCode] = useState("");
  const [pgName, setPgName] = useState("");
  const [seedName, setSeedName] = useState("");
  const [seedClass, setSeedClass] = useState("");
  const [seedVariety, setSeedVariety] = useState("");
  const [cropType, setCropType] = useState("");
  const [culltivationarea, setCulltivationarea] = useState("");
  const [productionquantity, setProductionquantity] = useState("");
  const [baseprice, setBaseprice] = useState("");
  const [saleprice, setSaleprice] = useState("");
  const [saleqty, setSaleqty] = useState("");
  const [addincome, setAddincome] = useState("");
  const [tlseed, settlseed] = useState("");
  const [consumption, setConsumption] = useState("");
  const [totalprice, setTotalprice] = useState("");
  const [usedastlseed, setUsedastlseed] = useState("");
  const [plannedarea, setPlannesarea] = useState("");

  const [page, setPage] = useState(1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [totalItems, setTotalitems] = useState(0);
  const [totalpage, setTotalpage] = useState(0);
  const [selectedSeasonId, setSelectedSeasonId] = useState(0);
  const [castes, setCastes] = useState([]);
  const [selectedCasteId, setSelectedCasteId] = useState(0);

  const [data, setData] = useState([]);
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);


  useEffect(() => {
    fetchData();
  }, [selectedSeasonId, selectedCasteId, pgcode, pgName, seedName, farmername, seedClass, seedVariety, cropType
    , plannedarea, culltivationarea, productionquantity, baseprice, saleprice, saleqty, addincome, consumption
    , totalprice, usedastlseed, plannedarea
    , page, pageSize, year]);

  const fetchData = async () => {
    try {
      const response = await apiService.post(
        "/market-linkage/ProductionCumAreaReport/getReport",
        {

          seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
          casteId: selectedCasteId ? Number(selectedCasteId) : 0,
          farmerName: farmername,
          pgCode: pgcode,
          pgName: pgName,
          year: year ? Number(year) : null,
          salePrice: saleprice || null,
          basePrice: baseprice || null,
          tlSeed: usedastlseed || null,
          consumption: consumption || null,
          sellQuantity: saleqty || null,
          seedName: seedName,
          seedClass: seedClass,
          seedVariety: seedVariety,
          totalPrice: totalprice || null,
          cropType: cropType,
          userId: 0,
          plannedArea: plannedarea || null,
          cultivatedArea: culltivationarea || null,
          totalProduction: productionquantity || null,
          additionalIncome: addincome || null,
          pageSize: pageSize,
          pageNumber: page,
        }


      );

      if (response.data.status) {
        setData(response.data.body.data);
        const totalRecords = response.data.body.recordsCount || 0;
        const totalPages = pageSize > 0 ? Math.ceil(totalRecords / pageSize) : 0;

        setFilteredRows(data);
        setTotalitems(totalRecords);
        setTotalpage(totalPages);
        setRows(data);
        setRowCount(totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setFilteredRows([]);
      setTotalitems(0);
      setTotalpage(0);
      setRows([]);
      setRowCount(0);
    }
  };


  const fetchSeasons = async () => {
    try {
      const response = await apiService.get("/seasons/get-all");
      setSeasons(response.data);
    } catch (error) {
      console.error("Error fetching seasons:", error);
    }
  };

  const fetchCastes = async () => {
    try {
      const response = await apiService.get("/castes/get-all");
      setCastes(response.data);
    } catch (error) {
      console.error("Error fetching castes:", error);
    }
  };

  useEffect(() => {

    fetchYears();
    fetchSeasons();
    fetchCastes();
  }, []);


  const fetchYears = async () => {
    try {
      const response = await apiService.get("/years/get-all");
      setYears(response.data);
      const currentYear = new Date().getFullYear();
      const defaultYear = response.data.find((yr) => yr.yearValue === currentYear);

      setYear(defaultYear ? defaultYear.yearValue : response.data[0].yearValue);
    } catch (error) {
      console.error("Error fetching years:", error);
    }
  };


  useEffect(() => {

    fetchYears();
  }, []);


  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const startItem = (page - 1) * 10 + 1;
  const endItem = Math.min(page * 10, totalItems);

  const renderPaginationItems = () => {
    const paginationItems = [];
    const maxPagesToShow = 7;
    const startPages = 3;
    const endPages = 2;

    if (totalpage <= maxPagesToShow) {
      for (let pages = 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    } else {
      // Show first 3 pages
      for (let pages = 1; pages <= startPages; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      // Show ellipsis if necessary
      if (page > startPages + 1) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }

      // Show the middle pages around the current page
      const middlePages = [];
      const startMiddlePage = Math.max(page - 1, startPages + 1);
      const endMiddlePage = Math.min(page + 1, totalpage - endPages);

      for (let pages = startMiddlePage; pages <= endMiddlePage; pages++) {
        middlePages.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      paginationItems.push(...middlePages);

      // Show ellipsis if necessary
      if (page < totalpage - endPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      // Show last 2 pages
      for (let pages = totalpage - endPages + 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    }
    return paginationItems;
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const exportToCSV = async (selectedYear) => {
    try {
      const payload = {

        seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
        casteId: selectedCasteId ? Number(selectedCasteId) : 0,
        farmerName: farmername,
        pgCode: pgcode,
        pgName: pgName,
        year: year ? Number(year) : null,
        salePrice: saleprice || null,
        basePrice: baseprice || null,
        tlSeed: usedastlseed || null,
        consumption: consumption || null,
        sellQuantity: saleqty || null,
        seedName: seedName,
        seedClass: seedClass,
        seedVariety: seedVariety,
        totalPrice: totalprice,
        cropType: cropType,
        userId: 0,
        plannedArea: plannedarea || null,
        cultivatedArea: culltivationarea || null,
        totalProduction: productionquantity || null,
        additionalIncome: addincome || null,
        pageSize: pageSize,
        pageNumber: page,
      };

      const response = await apiService.post("/market-linkage/ProductionCumAreaReport/getReport", payload);

      if (response.data.status) {
        const data = response.data.body.data || [];

        if (data.length === 0) {
          alert("No data available to export.");
          return;
        }

        // Define headers in required order
        const headers = [
          "Season Name",
          "PG Code",
          "Farmer Name",
          "Caste",
          "Seed Name",
          "Seed Class",
          "Seed Variety",
          "Crop Type",
          "Planned Area",
          "Cultivated Area",
          "Total Production",
          "Base Price",
          "Sale Price",
          "Total Price",
          "Additional Income",
          "TL Seed",
          "Consumption",
        ];


        // Map data to match the header order
        const rows = data.map((item) => [
          item.seasonName ?? "",
          item.pgCode ?? "",
          item.farmerName ?? "",
          item.caste ?? "",
          item.seedName ?? "",
          item.seedClass ?? "",
          item.seedVariety ?? "",
          item.cropType ?? "",
          item.plannedArea ?? "",
          item.cultivatedArea ?? "",
          item.totalProduction ?? "",
          item.basePrice ?? "",
          item.salePrice ?? "",
          item.totalPrice ?? "",
          item.additionalIncome ?? "",
          item.tlSeed ?? "",
          item.consumption ?? "",
        ]);


        // Convert array to CSV format
        const csvContent = [
          `Report: ${reportName}`,
          `Year: ${selectedYear}`,
          headers.join(","),
          ...rows.map(row => row.map(value => `"${value}"`).join(",")) // Ensure values with commas are wrapped in quotes
        ].join("\n");

        // Create and download CSV file
        const blob = new Blob([csvContent], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${reportName.replace(/\s+/g, '_')}_${selectedYear}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else {
        alert("Failed to fetch data from API.");
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      alert("An error occurred while fetching data.");
    }
  };

  const exportToXLSX = async (selectedYear) => {
    try {
      const payload = {
        seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
        casteId: selectedCasteId ? Number(selectedCasteId) : 0,
        farmerName: farmername,
        pgCode: pgcode,
        pgName: pgName,
        year: year ? Number(year) : null,
        salePrice: saleprice || null,
        basePrice: baseprice || null,
        tlSeed: usedastlseed || null,
        consumption: consumption || null,
        sellQuantity: saleqty || null,
        seedName: seedName,
        seedClass: seedClass,
        seedVariety: seedVariety,
        totalPrice: totalprice,
        cropType: cropType,
        userId: 0,
        plannedArea: plannedarea || null,
        cultivatedArea: culltivationarea || null,
        totalProduction: productionquantity || null,
        additionalIncome: addincome || null,
        pageSize: pageSize,
        pageNumber: page,
      };

      const response = await apiService.post("/market-linkage/ProductionCumAreaReport/getReport", payload);

      if (response.data.status) {
        const data = response.data.body.data || [];

        if (data.length === 0) {
          alert("No data available to export.");
          return;
        }

        // Define headers
        const headers = [
          "Season Name",
          "PG Code",
          "Farmer Name",
          "Caste",
          "Seed Name",
          "Seed Class",
          "Seed Variety",
          "Crop Type",
          "Planned Area",
          "Cultivated Area",
          "Total Production",
          "Base Price",
          "Sale Price",
          "Total Price",
          "Additional Income",
          "TL Seed",
          "Consumption",
        ];


        // Map data to match the header order
        const rows = data.map((item) => [
          item.seasonName ?? "",
          item.pgCode ?? "",
          item.farmerName ?? "",
          item.caste ?? "",
          item.seedName ?? "",
          item.seedClass ?? "",
          item.seedVariety ?? "",
          item.cropType ?? "",
          item.plannedArea ?? "",
          item.cultivatedArea ?? "",
          item.totalProduction ?? "",
          item.basePrice ?? "",
          item.salePrice ?? "",
          item.totalPrice ?? "",
          item.additionalIncome ?? "",
          item.tlSeed ?? "",
          item.consumption ?? "",
        ]);

        // Create worksheet
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Generate and download file
        const fileName = `ProductionCropArea_Report_${selectedYear}.xlsx`;
        XLSX.writeFile(workbook, fileName);
      } else {
        alert("Failed to fetch data from API.");
      }
    } catch (error) {
      console.error("Error fetching data: ", error);
      alert("An error occurred while fetching data.");
    }
  };





  return (
    <div className="container-fluid" style={{ maxHeight: "100vh", overflowX: "auto" }}>      {/* Fixed Year & Season Selection Section */}
      <div className="row mt-3">
        <div className="d-flex align-items-center me-4 p-2 bg-white shadow-sm"
          style={{ position: "sticky", top: 0, zIndex: 10 }}>

          {/* Year Dropdown */}
          <div className="d-flex align-items-center me-3">
            <div className="me-2 fw-bold">Year</div>
            <select
              className="form-select form-select-sm"
              style={{ width: "100px" }}
              value={year || 0}
              onChange={(e) => {
                setYear(Number(e.target.value));
              }}
            >
              <option value={0} disabled>Select a Year</option>
              {years.map((yr) => (
                <option key={yr.yearId} value={yr.yearValue}>
                  {yr.yearValue}
                </option>
              ))}
            </select>


            {/* Season Dropdown */}
            <div className="d-flex align-items-center">
              {/* <div className="me-2 fw-bold">Season</div>
            <select
              className="form-select form-select-sm"
              style={{ width: "120px" }}
              value={season || ""}
              onChange={(e) => {
                setSeason(Number(e.target.value));  // Storing seasonId
              }}
            >
              <option value="" disabled>Select Season</option>
              {seasons.map((sn) => (
                <option key={sn.seasonId} value={sn.seasonId}>
                  {sn.seasonName}
                </option>
              ))}
            </select> */}
              <Button
                variant="contained"
                color="primary"
                sx={{
                  marginLeft: "20px",
                  padding: "10px 20px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "none",
                  borderRadius: "12px",
                  background: "linear-gradient(90deg, #1976d2, #42a5f5)",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                  "&:hover": {
                    background: "linear-gradient(90deg, #1565c0, #2196f3)",
                  },
                }}
                startIcon={<Download />}
                onClick={handleMenuOpen}
              >
                Export Data
              </Button>

              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem onClick={() => { exportToCSV(year); handleMenuClose(); }}>Download as CSV</MenuItem>
                <MenuItem onClick={() => { exportToXLSX(year); handleMenuClose(); }}>Download as XLSX</MenuItem>
              </Menu>
            </div>

          </div>

        </div></div>

      <div className="row mt-3">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body table-responsive p-0"
              style={{
                minHeight: "60vh",
                overflowX: "auto",
                scrollbarWidth: "thin",
                scrollbarColor: "#ccc transparent",
              }}>
              <table className="table table-hover table-bordered text-nowrap mb-0">
                <thead >
                  <tr>

                    <th>
                      Season
                      <br />
                      <select
                        className="form-control form-control-sm"
                        value={selectedSeasonId}
                        onChange={(e) => {
                          setSelectedSeasonId(e.target.value);
                          setPage(1);
                        }}
                      >
                        <option value={0}>All</option>
                        {seasons.map((season) => (
                          <option key={season.seasonId} value={season.seasonId}>
                            {season.seasonName}
                          </option>
                        ))}
                      </select>
                    </th>

                    <th>
                      Pgcode
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={pgcode}
                        onChange={(e) => {
                          setPgCode(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      Farmer Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={farmername}
                        onChange={(e) => {
                          setFarmerName(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      Caste
                      <br />
                      <select
                        className="form-control form-control-sm"
                        value={selectedCasteId || ""}
                        onChange={(e) => {
                          setSelectedCasteId(e.target.value ? Number(e.target.value) : null);
                          setPage(1);
                        }}
                      >
                        <option value="">All</option>
                        {castes.map((caste) => (
                          <option key={caste.casteId} value={caste.casteId}>
                            {caste.caste}
                          </option>
                        ))}
                      </select>
                    </th>

                    <th>
                      Seed Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={seedName}
                        onChange={(e) => {
                          setSeedName(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      Seed Class
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={seedClass}
                        onChange={(e) => {
                          setSeedClass(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>Seed Variety
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={seedVariety}
                        onChange={(e) => {
                          setSeedVariety(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>

                    <th>Crop Type
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={cropType}
                        onChange={(e) => {
                          setCropType(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>Plannedarea
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={plannedarea}
                        onChange={(e) => {
                          setPlannesarea(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>Culltivation area
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={culltivationarea}
                        onChange={(e) => {
                          setCulltivationarea(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>Production Qty
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={productionquantity}
                        onChange={(e) => {
                          setProductionquantity(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>Base Price
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={baseprice}
                        onChange={(e) => {
                          setBaseprice(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>Sale Price
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={saleprice}
                        onChange={(e) => {
                          setSaleprice(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>Total Price
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={totalprice}
                        onChange={(e) => {
                          setTotalprice(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>Add. Income
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={addincome}
                        onChange={(e) => {
                          setAddincome(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>Used-As-Tlseed
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={usedastlseed}
                        onChange={(e) => {
                          setUsedastlseed(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>Consumption
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={consumption}
                        onChange={(e) => {
                          setConsumption(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>


                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => (
                    <tr key={index}>
                      <td>{item.seasonName}</td>
                      <td>{item.pgCode}</td>
                      <td>{item.farmerName}</td>
                      <td>{item.caste}</td>
                      <td>{item.seedName}</td>
                      <td>{item.seedClass}</td>
                      <td>{item.seedVariety}</td>
                      <td>{item.cropType}</td>
                      <td>{item.plannedArea}</td>
                      <td>{item.cultivatedArea}</td>
                      <td>{item.totalProduction}</td>
                      <td>{item.basePrice}</td>
                      <td>{item.salePrice}</td>
                      <td>{item.totalPrice}</td>
                      <td>{item.additionalIncome}</td>
                      <td>{item.tlSeed}</td>
                      <td>{item.consumption}</td>
                      <td className="py-0">
                        {/* <button
                className="btn btn-md me-2"
                onClick={() => handleEdit(data.id)}
                title="Edit"
              >
                <FaRegEdit />
              </button>
              <button
                className="btn btn-md"
                onClick={() => handleDelete(data.id)}
                title="Delete"
              >
                <FaTrash />
              </button> */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div></div></div></div>


      <div className="row mt-3">
        <div className='d-flex justify-content-between pb-0'>
          <div className='p-2'>
            Showing {startItem} to {endItem} of {totalItems} items
          </div>
          <div className='p-2'>
            <Pagination className="mb-0">
              <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
              <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
              {renderPaginationItems()}
              <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalpage} />
              <Pagination.Last onClick={() => handlePageChange(totalpage)} disabled={page === totalpage} />
            </Pagination>
          </div>
        </div>
      </div>


    </div>
  );
};

const Clusterdata = ({ reportName }) => {
  const [filteredRows, setFilteredRows] = useState([]);
  const [village, setVillage] = useState("");
  const [gp, setGp] = useState("");
  const [block, setBlock] = useState("");
  const [district, setDistrict] = useState("");
  const [mip, setMip] = useState("");
  const [season, setSeason] = useState("");

  const [pgName, setPgName] = useState("");
  const [type, setType] = useState("");
  const [date, setDate] = useState("");
  const [topic, setTopic] = useState("");
  const [farmersNo, setFarmersNo] = useState("");
  const [male, setMale] = useState("");
  const [female, setFemale] = useState("");
  const [sc, setSc] = useState("");
  const [st, setSt] = useState("");
  const [obc, setObc] = useState("");
  const [general, setGeneral] = useState("");
  const [resourcePerson, setResourcePerson] = useState("");
  const [designation, setDesignation] = useState("");


  const [page, setPage] = useState(1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [totalItems, setTotalitems] = useState(0);
  const [totalpage, setTotalpage] = useState(0);

  const [data, setData] = useState([]);
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [selectedSeasonId, setSelectedSeasonId] = useState(0);



  const fetchYears = async () => {
    try {
      const response = await apiService.get("/years/get-all");
      setYears(response.data);
      const currentYear = new Date().getFullYear();
      const defaultYear = response.data.find((yr) => yr.yearValue === currentYear);

      setYear(defaultYear ? defaultYear.yearValue : response.data[0].yearValue);
    } catch (error) {
      console.error("Error fetching years:", error);
    }
  };


  useEffect(() => {

    fetchYears();
  }, []);



  const fetchSeasons = async () => {
    try {
      const response = await apiService.get("/seasons/get-all");
      setSeasons(response.data);
    } catch (error) {
      console.error("Error fetching seasons:", error);
    }
  };



  useEffect(() => {

    fetchYears();
    fetchSeasons();
  }, []);


  useEffect(() => {
    fetchData();
  }, [village, gp, block, district, mip, selectedSeasonId, type, date, topic, pgName, resourcePerson, designation, year, page, pageSize]);

  const fetchData = async () => {
    try {
      const response = await apiService.post("/training/report", {
        block: block,
        district: district,
        seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
        typeName: type,
        topic: topic,
        pgName: pgName,
        resourcePerson: resourcePerson,
        designation: designation,
        village: village,
        gp: gp,
        date: date,
        yearValue: year ? Number(year) : null,
        clusterTrainingType: "",
        pageNumber: page,
        pageSize: pageSize,
        mip: mip,
      });

      if (response.data && response.data.trainingData) {
        const trainingData = response.data.trainingData; // Extract training data
        const totalRecords = trainingData.length || 0;
        const totalPages = pageSize > 0 ? Math.ceil(totalRecords / pageSize) : 0;

        setData(trainingData);
        setFilteredRows(trainingData);
        setTotalitems(totalRecords);
        setTotalpage(totalPages);
        setRows(trainingData);
        setRowCount(totalRecords);
      } else {
        setFilteredRows([]);
        setTotalitems(0);
        setTotalpage(0);
        setRows([]);
        setRowCount(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setFilteredRows([]);
      setTotalitems(0);
      setTotalpage(0);
      setRows([]);
      setRowCount(0);
    }
  };




  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const startItem = (page - 1) * 10 + 1;
  const endItem = Math.min(page * 10, totalItems);

  const renderPaginationItems = () => {
    const paginationItems = [];
    const maxPagesToShow = 7;
    const startPages = 3;
    const endPages = 2;

    if (totalpage <= maxPagesToShow) {
      for (let pages = 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    } else {
      // Show first 3 pages
      for (let pages = 1; pages <= startPages; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      // Show ellipsis if necessary
      if (page > startPages + 1) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }

      // Show the middle pages around the current page
      const middlePages = [];
      const startMiddlePage = Math.max(page - 1, startPages + 1);
      const endMiddlePage = Math.min(page + 1, totalpage - endPages);

      for (let pages = startMiddlePage; pages <= endMiddlePage; pages++) {
        middlePages.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      paginationItems.push(...middlePages);

      // Show ellipsis if necessary
      if (page < totalpage - endPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      // Show last 2 pages
      for (let pages = totalpage - endPages + 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    }
    return paginationItems;
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const exportToCSV = async (selectedYear) => {
    const apiUrl = "https://api.icarda.ajatus.in/api/training/report";
    const payload = {
      block: block,
      district: district,
      seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
      typeName: type,
      topic: topic,
      pgName: pgName,
      resourcePerson: resourcePerson,
      designation: designation,
      village: village,
      gp: gp,
      date: date,
      yearValue: year ? Number(year) : null,
      clusterTrainingType: "",
      pageNumber: page,
      pageSize: 1000000000,
      mip: mip
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();
      if (!data.trainingData || data.trainingData.length === 0) {
        alert("No data available for the selected year.");
        return;
      }

      const headers = [
        "Village", "GP", "Block", "District", "MIP", "Season", "Type", "Date", "Topic",
        "PG Names", "Farmer Count", "Male Count", "Female Count", "SC Count",
        "ST Count", "OBC Count", "GEN Count", "Resource Person", "Designation"
      ];

      const rows = data.trainingData.map(item => [
        item.village || "",
        item.gp || "",
        item.block || "",
        item.district || "",
        item.mip || "", // MIP (Not present in API response, left empty)
        item.season || "",
        item.typeName || "",
        item.date ? format(parseISO(item.date), "dd-MM-yyyy") : "N/A",
        item.topic || "",
        item.pgNames || "",
        item.farmerCount || "",
        item.maleCount || "",
        item.femaleCount || "",
        item.scCount || "",
        item.stCount || "",
        item.obcCount || "",
        item.genCount || "",
        item.resourceName || "",
        item.designation || ""
      ]);

      const reportRow = [`Report: Training Report`];
      const yearRow = [`Year: ${selectedYear}`];
      const csvContent = [
        reportRow.join(","),
        yearRow.join(","),
        headers.join(","),
        ...rows.map(row => row.join(","))
      ].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Training_Report_${selectedYear}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("Failed to fetch data for CSV export.");
    }
  };



  const exportToXLSX = async (selectedYear) => {
    const apiUrl = "https://api.icarda.ajatus.in/api/training/report";
    const payload = {
      block: block,
      district: district,
      seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,
      typeName: type,
      topic: topic,
      pgName: pgName,
      resourcePerson: resourcePerson,
      designation: designation,
      village: village,
      gp: gp,
      date: date,
      yearValue: year ? Number(year) : null,
      clusterTrainingType: "",
      pageNumber: page,
      pageSize: 100000000,
      mip: mip
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      const data = await response.json();
      if (!data.trainingData || data.trainingData.length === 0) {
        alert("No data available for the selected year.");
        return;
      }

      const headers = [
        "Village", "GP", "Block", "District", "MIP", "Season", "Type", "Date", "Topic",
        "PG Names", "Farmer Count", "Male Count", "Female Count", "SC Count",
        "ST Count", "OBC Count", "GEN Count", "Resource Person", "Designation"
      ];

      const rows = data.trainingData.map(item => [
        item.village || "",
        item.gp || "",
        item.block || "",
        item.district || "",
        item.mip || "", // MIP (Not present in API response, left empty)
        item.season || "",
        item.typeName || "",
        item.date ? format(parseISO(item.date), "dd-MM-yyyy") : "N/A",
        item.topic || "",
        item.pgNames || "",
        item.farmerCount || "",
        item.maleCount || "",
        item.femaleCount || "",
        item.scCount || "",
        item.stCount || "",
        item.obcCount || "",
        item.genCount || "",
        item.resourceName || "",
        item.designation || ""
      ]);

      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const fileName = `Training_Report_${selectedYear}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("Failed to fetch data for XLSX export.");
    }
  };



  return (
    <div className="container-fluid" style={{ maxHeight: "100vh", overflowX: "auto" }}>

      <div className="row mt-3">
        <div className="d-flex align-items-center me-4 p-2 bg-white shadow-sm"
          style={{ position: "sticky", top: 0, zIndex: 10 }}>

          {/* Year Dropdown */}
          <div className="d-flex align-items-center me-3">
            <div className="me-2 fw-bold">Year</div>
            <select
              className="form-select form-select-sm"
              style={{ width: "100px" }}
              value={year || 0}
              onChange={(e) => {
                setYear(Number(e.target.value));
              }}
            >
              <option value={0} disabled>Select a Year</option>
              {years.map((yr) => (
                <option key={yr.yearId} value={yr.yearValue}>
                  {yr.yearValue}
                </option>
              ))}
            </select>


            {/* Season Dropdown */}
            <div className="d-flex align-items-center">
              {/* <div className="me-2 fw-bold">Season</div>
            <select
              className="form-select form-select-sm"
              style={{ width: "120px" }}
              value={season || ""}
              onChange={(e) => {
                setSeason(Number(e.target.value));  // Storing seasonId
              }}
            >
              <option value="" disabled>Select Season</option>
              {seasons.map((sn) => (
                <option key={sn.seasonId} value={sn.seasonId}>
                  {sn.seasonName}
                </option>
              ))}
            </select> */}
              <Button
                variant="contained"
                color="primary"
                sx={{
                  marginLeft: "20px",
                  padding: "10px 20px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "none",
                  borderRadius: "12px",
                  background: "linear-gradient(90deg, #1976d2, #42a5f5)",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                  "&:hover": {
                    background: "linear-gradient(90deg, #1565c0, #2196f3)",
                  },
                }}
                startIcon={<Download />}
                onClick={handleMenuOpen}
              >
                Export Data
              </Button>

              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem onClick={() => { exportToCSV(year); handleMenuClose(); }}>Download as CSV</MenuItem>
                <MenuItem onClick={() => { exportToXLSX(year); handleMenuClose(); }}>Download as XLSX</MenuItem>
              </Menu>
            </div>

          </div>

        </div></div>
      <div className="row mt-3">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body table-responsive p-0"
              style={{
                minHeight: "60vh",
                overflowX: "auto",
                scrollbarWidth: "thin",
                scrollbarColor: "#ccc transparent",
              }}>
              <table className="table table-hover table-bordered text-nowrap mb-0">
                <thead style={{ whiteSpace: "nowrap" }}>
                  <tr>
                    <th >
                      Village
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={village}
                        onChange={(e) => {
                          setVillage(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>

                    <th>
                      GP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={gp}
                        onChange={(e) => {
                          setGp(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>

                    <th>
                      Block
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={block}
                        onChange={(e) => {
                          setBlock(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>

                    <th>
                      District
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={district}
                        onChange={(e) => {
                          setDistrict(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>

                    <th>
                      MIP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={mip}
                        onChange={(e) => {
                          setMip(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>

                    <th>
                      Season
                      <br />
                      <select
                        className="form-control form-control-sm"
                        value={selectedSeasonId}
                        onChange={(e) => {
                          setSelectedSeasonId(e.target.value);
                          setPage(1);
                        }}
                      >
                        <option value={0}>All</option>
                        {seasons.map((season) => (
                          <option key={season.seasonId} value={season.seasonId}>
                            {season.seasonName}
                          </option>
                        ))}
                      </select>
                    </th>

                    <th>
                      Type
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={type}
                        onChange={(e) => {
                          setType(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>

                    <th>
                      Date
                      <br />
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        value={date}
                        onChange={(e) => {
                          setDate(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>

                    <th>
                      Topic
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={topic}
                        onChange={(e) => {
                          setTopic(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>

                    <th>
                      PG Name
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={pgName}
                        onChange={(e) => {
                          setPgName(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>

                    <th>
                      Farmers (No.)
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={farmersNo}
                onChange={(e) => {
                  setFarmersNo(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>

                    <th>
                      Male
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={male}
                onChange={(e) => {
                  setMale(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>

                    <th>
                      Female
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={female}
                onChange={(e) => {
                  setFemale(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>

                    <th>
                      SC
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={sc}
                onChange={(e) => {
                  setSc(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>

                    <th>
                      ST
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={st}
                onChange={(e) => {
                  setSt(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>

                    <th>
                      OBC
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={obc}
                onChange={(e) => {
                  setObc(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>

                    <th>
                      General
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={general}
                onChange={(e) => {
                  setGeneral(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>

                    <th>
                      Resource Person
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={resourcePerson}
                        onChange={(e) => {
                          setResourcePerson(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>

                    <th>
                      Designation
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={designation}
                        onChange={(e) => {
                          setDesignation(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>


                  </tr>
                </thead>
                <tbody style={{ fontSize: "14px" }}>
                  {filteredRows.map((data, index) => (
                    <tr key={index}>
                      <td className="py-0">{data.village}</td>
                      <td className="py-0">{data.gp}</td>
                      <td className="py-0">{data.block}</td>
                      <td className="py-0">{data.district}</td>
                      <td className="py-0">{data.mip}</td>
                      <td className="py-0">{data.season}</td>
                      <td className="py-0">{data.typeName}</td>
                      <td className="py-0">{data.date ? format(parseISO(data.date), "dd-MM-yyyy") : "N/A"}</td>
                      <td className="py-0">{data.topic}</td>
                      <td className="py-0">{data.pgNames}</td>
                      <td className="py-0">{data.farmerCount}</td>
                      <td className="py-0">{data.maleCount}</td>
                      <td className="py-0">{data.femaleCount}</td>
                      <td className="py-0">{data.scCount}</td>
                      <td className="py-0">{data.stCount}</td>
                      <td className="py-0">{data.obcCount}</td>
                      <td className="py-0">{data.genCount}</td>
                      <td className="py-0">{data.resourceName}</td>
                      <td className="py-0">{data.designation}</td>


                    </tr>
                  ))}
                </tbody>
              </table>
            </div></div></div></div>

      <div className="row mt-3">
        <div className='d-flex justify-content-between pb-0'>
          <div className='p-2'>
            Showing {startItem} to {endItem} of {totalItems} items
          </div>
          <div className='p-2'>
            <Pagination className="mb-0">
              <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
              <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
              {renderPaginationItems()}
              <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalpage} />
              <Pagination.Last onClick={() => handlePageChange(totalpage)} disabled={page === totalpage} />
            </Pagination>
          </div>
        </div>
      </div>

    </div>
  );
};

const PalsesVariety = ({ reportName }) => {
  const [filteredRows, setFilteredRows] = useState([]);
  const [season, setSeason] = useState("");
  const [dist, setDist] = useState("");
  const [block, setBlock] = useState("");
  const [mip, setMip] = useState("");
  const [location, setLocation] = useState("");
  const [crop, setCrop] = useState("");
  const [varieties, setVarieties] = useState("");
  const [showingDate, setShowingDate] = useState("");
  const [plotSize, setPlotSize] = useState("");
  const [replication, setReplication] = useState("");
  const [farmersNo, setFarmersNo] = useState("");
  const [male, setMale] = useState("");
  const [female, setFemale] = useState("");
  const [sc, setSc] = useState("");
  const [st, setSt] = useState("");
  const [obc, setObc] = useState("");
  const [district, setDistrict] = useState("");
  const [village, setVillage] = useState("");
  const [pgName, setPgName] = useState("");
  const [resourcePerson, setResourcePerson] = useState("");
  const [topic, setTopic] = useState("");



  const [page, setPage] = useState(1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [totalItems, setTotalitems] = useState(0);
  const [totalpage, setTotalpage] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);


  const [data, setData] = useState([]);
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [selectedSeasonId, setSelectedSeasonId] = useState(0);
  const [gen, setGen] = useState("");


  
  const fetchYears = async () => {
    try {
      const response = await apiService.get("/years/get-all");
      setYears(response.data);
      const currentYear = new Date().getFullYear();
      const defaultYear = response.data.find((yr) => yr.yearValue === currentYear);

      setYear(defaultYear ? defaultYear.yearValue : response.data[0].yearValue);
    } catch (error) {
      console.error("Error fetching years:", error);
    }
  };
  const fetchSeasons = async () => {
    try {
      const response = await apiService.get("/seasons/get-all");
      setSeasons(response.data);
    } catch (error) {
      console.error("Error fetching seasons:", error);
    }
  };

  useEffect(() => {
    fetchSeasons();
    fetchYears();
  }, []);

  
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };



  useEffect(() => {
    fetchData();
  }, [selectedSeasonId,district,block,mip,village,topic,pgName,page,year,pageSize,crop,varieties,location,showingDate]);

  const fetchData = async () => {
    try {
      const response = await apiService.post(
        "/technology/technology-park-report-with-filter",
        {
          seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,

          dist: district || null,
          block: block || null,
          mip: mip || null,
          location: location || null,
          crop: crop || null,
          varieties: varieties || null,
          plotSize: 0.0,
          replication: 0,
          farmersNo: 0,
          male: 0,
          female: 0,
          sc: 0,
          st: 0,
          obc: 0,
          pageNumber: page,
          pageSize: pageSize,
          yearValue: year ? Number(year) : null,
          showingDate: showingDate || null,
        }
      );

      if (response.data && response.data.body) {
        const trainingData = response.data.body.data || [];
        const totalRecords = response.data.body.recordsCount || 0;
        const totalPages = response.data.body.pageCount || 0;

        setData(trainingData);
        setFilteredRows(trainingData);
        setTotalitems(totalRecords);
        setTotalpage(totalPages);
        setRows(trainingData);
        setRowCount(totalRecords);
      } else {
        setFilteredRows([]);
        setTotalitems(0);
        setTotalpage(0);
        setRows([]);
        setRowCount(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setFilteredRows([]);
      setTotalitems(0);
      setTotalpage(0);
      setRows([]);
      setRowCount(0);
    }
  };


  const startItem = (page - 1) * 10 + 1;
  const endItem = Math.min(page * 10, totalItems);

  const renderPaginationItems = () => {
    const paginationItems = [];
    const maxPagesToShow = 7;
    const startPages = 3;
    const endPages = 2;

    if (totalpage <= maxPagesToShow) {
      for (let pages = 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    } else {
      // Show first 3 pages
      for (let pages = 1; pages <= startPages; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      // Show ellipsis if necessary
      if (page > startPages + 1) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }

      // Show the middle pages around the current page
      const middlePages = [];
      const startMiddlePage = Math.max(page - 1, startPages + 1);
      const endMiddlePage = Math.min(page + 1, totalpage - endPages);

      for (let pages = startMiddlePage; pages <= endMiddlePage; pages++) {
        middlePages.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      paginationItems.push(...middlePages);

      // Show ellipsis if necessary
      if (page < totalpage - endPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      // Show last 2 pages
      for (let pages = totalpage - endPages + 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    }
    return paginationItems;
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };






  const exportToCSV = async (selectedYear) => {
      const payload = {
          seasonId: 0,
          dist: null,
          block: null,
          mip: null,
          location: null,
          crop: null,
          varieties: null,
          plotSize: 0,
          replication: 0,
          farmersNo: 0,
          male: 0,
          female: 0,
          sc: 0,
          st: 0,
          obc: 0,
          pageNumber: 1,
          pageSize: 10,
          yearValue: selectedYear,
          showingDate: null
      };
  
      try {
          const response = await apiService.post("/technology/technology-park-report-with-filter", payload, {
              headers: {
                  "Content-Type": "application/json"
              }
          });
  
          const data = response.data;
  
          if (!data.body || !data.body.data || data.body.data.length === 0) {
              alert("No data available for the selected year.");
              return;
          }
  
          const headers = [
              "Season Name", "District Name", "Block Name", "MIPs", "Location", "Seed Names", 
              "Variety Name", "Plot Size", "Replication", "Farmers Count", 
              "Male", "Female", "SC", "ST", "OBC"
          ];
  
          const rows = data.body.data.map(row => [
              `"${row.seasonName || ""}"`,
              `"${row.districtName || ""}"`,
              `"${row.blockName || ""}"`,
              `"${row.mips || ""}"`,
              `"${row.location || ""}"`,
              `"${row.seedNames || ""}"`,
              `"${row.varietyName || ""}"`,
              `"${row.plotSize || ""}"`,
              `"${row.replication || ""}"`,
              `"${row.farmersCount || ""}"`,
              `"${row.male || ""}"`,
              `"${row.female || ""}"`,
              `"${row.sc || ""}"`,
              `"${row.st || ""}"`,
              `"${row.obc || ""}"`
          ]);
  
          const csvContent = [
              `"Report: ${reportName}"`,
              `"Year: ${selectedYear}"`,
              headers.map(header => `"${header}"`).join(","),  // Add headers correctly
              ...rows.map(row => row.join(","))               // Add data rows correctly
          ].join("\n");
  
          const blob = new Blob([csvContent], { type: "text/csv" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `${reportName.replace(/\s+/g, "_")}_${selectedYear}.csv`; // Remove spaces in filename
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
      } catch (error) {
          console.error("Error exporting CSV:", error);
          alert("Error exporting CSV. Please try again later.");
      }
  };
  



  const exportToXLSX = async (selectedYear) => {
    const reportName = "Technology Park Report"; // Ensure this is defined

    const payload = {
        seasonId: 0,
        dist: null,
        block: null,
        mip: null,
        location: null,
        crop: null,
        varieties: null,
        plotSize: 0,
        replication: 0,
        farmersNo: 0,
        male: 0,
        female: 0,
        sc: 0,
        st: 0,
        obc: 0,
        pageNumber: 1,
        pageSize: 10,
        yearValue: selectedYear,
        showingDate: null
    };

    try {
        const response = await apiService.post("/technology/technology-park-report-with-filter", payload, {
            headers: {
                "Content-Type": "application/json"
            }
        });

        const data = response.data;

        if (!data.body || !data.body.data || data.body.data.length === 0) {
            alert("No data available for the selected year.");
            return;
        }

        const headers = [
            "Season Name", "District Name", "Block Name", "MIPs", "Location", "Seed Names",
            "Variety Name", "Plot Size", "Replication", "Farmers Count",
            "Male", "Female", "SC", "ST", "OBC"
        ];

        const rows = data.body.data.map(row => [
            row.seasonName || "",
            row.districtName || "",
            row.blockName || "",
            row.mips || "",
            row.location || "",
            row.seedNames || "",
            row.varietyName || "",
            row.plotSize || "",
            row.replication || "",
            row.farmersCount || "",
            row.male || "",
            row.female || "",
            row.sc || "",
            row.st || "",
            row.obc || ""
        ]);

        const reportRow = [`Report: ${reportName}`];
        const yearRow = [`Year: ${selectedYear}`];

        const worksheet = XLSX.utils.aoa_to_sheet([
            reportRow,   // Row 1: Report Name
            yearRow,     // Row 2: Year
            headers,     // Row 3: Table Headers
            ...rows      // Remaining Rows: Data
        ]);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        const fileName = `${reportName.replace(/\s+/g, '_')}_${selectedYear}.xlsx`;

        XLSX.writeFile(workbook, fileName);
    } catch (error) {
        console.error("Error exporting XLSX:", error);
        alert("Error exporting XLSX. Please try again later.");
    }
};





  return (
    <div className="container-fluid" style={{ maxHeight: "100vh", overflowX: "auto" }}>
      {/* Fixed Year & Season Selection Section */}
      <div className="row mt-3">
        <div className="d-flex align-items-center me-4 p-2 bg-white shadow-sm"
          style={{ position: "sticky", top: 0, zIndex: 10 }}>

          {/* Year Dropdown */}
          <div className="d-flex align-items-center me-3">
          <div className="me-2 fw-bold">Year</div>
            <select
              className="form-select form-select-sm"
              style={{ width: "100px" }}
              value={year || 0}
              onChange={(e) => {
                setYear(Number(e.target.value));
              }}
            >
              <option value={0} disabled>Select a Year</option>
              {years.map((yr) => (
                <option key={yr.yearId} value={yr.yearValue}>
                  {yr.yearValue}
                </option>
              ))}
            </select>

            {/* Season Dropdown */}
            <div className="d-flex align-items-center">
              
              <Button
                variant="contained"
                color="primary"
                sx={{
                  marginLeft: "20px",
                  padding: "10px 20px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "none",
                  borderRadius: "12px",
                  background: "linear-gradient(90deg, #1976d2, #42a5f5)",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                  "&:hover": {
                    background: "linear-gradient(90deg, #1565c0, #2196f3)",
                  },
                }}
                startIcon={<Download />}
                onClick={handleMenuOpen}
              >
                Export Data
              </Button>

              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem onClick={() => { exportToCSV(year); handleMenuClose(); }}>Download as CSV</MenuItem>
                <MenuItem onClick={() => { exportToXLSX(year); handleMenuClose(); }}>Download as XLSX</MenuItem>
              </Menu>
            </div>

          </div>

        </div></div>
      <div className="row mt-3">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body table-responsive p-0"
              style={{
                minHeight: "60vh",
                overflowX: "auto",
                scrollbarWidth: "thin",
                scrollbarColor: "#ccc transparent",
              }}>
              <table className="table table-bordered mb-0" style={{ minWidth: "1200px" }}>
                <thead style={{ whiteSpace: "nowrap" }}>
                  <tr>
                  <th>
                      Season
                      <br />
                      <select
                        className="form-control form-control-sm"
                        value={selectedSeasonId}
                        onChange={(e) => {
                          setSelectedSeasonId(e.target.value);
                          setPage(1);
                        }}
                      >
                        <option value={0}>All</option>
                        {seasons.map((season) => (
                          <option key={season.seasonId} value={season.seasonId}>
                            {season.seasonName}
                          </option>
                        ))}
                      </select>
                    </th>

                    <th>
                      District
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={district}
                        onChange={(e) => {
                          setDistrict(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>

                    <th>
                      Block
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={block}
                        onChange={(e) => {
                          setBlock(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>

                    <th>
                      MIP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={mip}
                        onChange={(e) => {
                          setMip(e.target.value);
                          setPage(1);
                        }}
                        style={{ width: "100px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                      />
                    </th>


                    <th>
                      Location
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={location}
                        onChange={(e) => {
                          setLocation(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>

                    {/* <th>
                      Crop
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={crop}
                        onChange={(e) => {
                          setCrop(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th> */}

                    <th style={{ width: "120px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                      Crop
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={crop}
                        onChange={(e) => {
                          setCrop(e.target.value);
                          setPage(1);
                        }}
                        style={{ width: "100px" }} // Adjust input width
                      />
                    </th>

                    <th>
                      Varieties
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={varieties}
                        onChange={(e) => {
                          setVarieties(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    

                 


                    <th>
                      Plot Size
                      <br />
                      {/* <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={plotSize}
                        onChange={(e) => {
                          setPlotSize(e.target.value);
                          setPage(1);
                        }}
                      /> */}
                    </th>

                    <th>
                     No. Replication
                      <br />
                      {/* <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={replication}
                        onChange={(e) => {
                          setReplication(e.target.value);
                          setPage(1);
                        }}
                      /> */}
                    </th>



                    <th>
                      No. of Farmers
                      <br />
                      {/* <input
                        type="number"
                        className="form-control form-control-sm"
                        value={farmersNo}
                        onChange={(e) => {
                          setFarmersNo(e.target.value);
                          setPage(1);
                        }}
                      /> */}
                    </th>

                    <th>
                      Male
                      <br />
                      {/* <input
                        type="number"
                        className="form-control form-control-sm"
                        value={male}
                        onChange={(e) => {
                          setMale(e.target.value);
                          setPage(1);
                        }}
                      /> */}
                    </th>

                    <th>
                      Female
                      <br />
                      {/* <input
                        type="number"
                        className="form-control form-control-sm"
                        value={female}
                        onChange={(e) => {
                          setFemale(e.target.value);
                          setPage(1);
                        }}
                      /> */}
                    </th>

                    <th>
                      SC
                      <br />
                      {/* <input
                        type="number"
                        className="form-control form-control-sm"
                        value={sc}
                        onChange={(e) => {
                          setSc(e.target.value);
                          setPage(1);
                        }}
                      /> */}
                    </th>

                    <th>
                      ST
                      <br />
                      {/* <input
                        type="number"
                        className="form-control form-control-sm"
                        value={st}
                        onChange={(e) => {
                          setSt(e.target.value);
                          setPage(1);
                        }}
                      /> */}
                    </th>

                    <th>
                      OBC
                      <br />
                      {/* <input
                        type="number"
                        className="form-control form-control-sm"
                        value={obc}
                        onChange={(e) => {
                          setObc(e.target.value);
                          setPage(1);
                        }}
                      /> */}
                    </th>
                    


                  </tr>
                </thead>
                <tbody style={{ fontSize: "14px" }}>
                  {filteredRows.map((data, index) => (
                    <tr key={index}>
                      <td className="py-0">{data.seasonName}</td>
                      <td className="py-0">{data.districtName}</td>
                      <td className="py-0">{data.blockName}</td>

                      <td className="py-0" title={data.mips}>
                        {data.mips?.length > 10 ? `${data.mips.substring(0, 10)}...` : data.mips}
                      </td>

                      <td className="py-0">{data.location}</td>
                      {/* <td className="py-0">{data.seedNames}</td> */}


                      <td className="py-0" title={data.seedNames}>
                        {data.seedNames?.length > 10 ? `${data.seedNames.substring(0, 10)}...` : data.seedNames}
                      </td>


                      <td className="py-0">{data.varietyName}</td>


                      
                      <td className="py-0">{data.plotSize}</td>
                      <td className="py-0">{data.replication}</td>

                      <td className="py-0">{data.farmersCount}</td>


                      <td className="py-0">{data.male}</td>
                      <td className="py-0">{data.female}</td>
                      <td className="py-0">{data.sc}</td>
                      <td className="py-0">{data.st}</td>
                      <td className="py-0">{data.obc}</td>




                    </tr>
                  ))}
                </tbody>
              </table>
            </div></div></div></div>

      <div className="row mt-3">
        <div className='d-flex justify-content-between pb-0'>
          <div className='p-2'>
            Showing {startItem} to {endItem} of {totalItems} items
          </div>
          <div className='p-2'>
            <Pagination className="mb-0">
              <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
              <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
              {renderPaginationItems()}
              <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalpage} />
              <Pagination.Last onClick={() => handlePageChange(totalpage)} disabled={page === totalpage} />
            </Pagination>
          </div>
        </div>
      </div>

    </div>
  );
};

const Breedertofoundation = ({ reportName }) => {
  const [filteredRows, setFilteredRows] = useState([]);
  const [season, setSeason] = useState("");
  const [dist, setDist] = useState("");
  const [block, setBlock] = useState("");
  const [mip, setMip] = useState("");
  const [crop, setCrop] = useState("");
  const [obc, setObc] = useState("");
  const [village, setVillage] = useState("");
  const [gp, setGp] = useState("");
  const [district, setDistrict] = useState("");
  const [variety, setVariety] = useState("");
  const [area, setArea] = useState("");
  const [certifiedSeed, setCertifiedSeed] = useState("");
  const [farmersInvolved, setFarmersInvolved] = useState("");
  const [page, setPage] = useState(1);
  const [male, setMale] = useState("");
  const [female, setFemale] = useState("");
  const [sc, setSc] = useState("");
  const [st, setSt] = useState("");
  const [year, setYear] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [totalItems, setTotalitems] = useState(0);
  const [totalpage, setTotalpage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectedSeasonId, setSelectedSeasonId] = useState(0);
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  const fetchYears = async () => {
    try {
      const response = await apiService.get("/years/get-all");
      setYears(response.data);
      const currentYear = new Date().getFullYear();
      const defaultYear = response.data.find((yr) => yr.yearValue === currentYear);

      setYear(defaultYear ? defaultYear.yearValue : response.data[0].yearValue);
    } catch (error) {
      console.error("Error fetching years:", error);
    }
  };


  useEffect(() => {

    fetchYears();
  }, []);

  const fetchSeasons = async () => {
    try {
      const response = await apiService.get("/seasons/get-all");
      setSeasons(response.data);
    } catch (error) {
      console.error("Error fetching seasons:", error);
    }
  };



  useEffect(() => {

    fetchYears();
    fetchSeasons();
  }, []);



  const fetchData = async () => {
    const payload = {
      seedClass: "FS",
      villageName: village || "",
      gpName: gp || "",
      blockName: block || "",
      districtName: district || "",
      mipName: mip || "",
      seed: crop || "",
      variety: variety || "",
      // season: "",
      seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,

      area: area || null,
      quantity: certifiedSeed || null,
      pageNumber: page,
      pageSize: pageSize,
      year: year ? Number(year) : null,
    };

    try {
      const response = await apiService.post("/crops/seed-class-wise-report", payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.data.status) {
        setFilteredRows(response.data.body.data || []);
        const data = response.data.body.data || [];
        const totalRecords = response.data.body.recordsCount || 0;
        const totalPages = pageSize > 0 ? Math.ceil(totalRecords / pageSize) : 0;

        setFilteredRows(data);
        setTotalitems(totalRecords);
        setTotalpage(totalPages);
        setRows(data);
        setRowCount(totalRecords);
      } else {
        console.error("Error fetching data:", response.data.message);
        setFilteredRows([]);
        setTotalitems(0);
        setTotalpage(0);
        setRows([]);
        setRowCount(0);
      }
    } catch (error) {
      console.error("API call failed:", error);
      setFilteredRows([]);

    }
  };

  useEffect(() => {
    fetchData();
  }, [village, gp, block, district, mip, crop, season, variety, area, selectedSeasonId, certifiedSeed, year, farmersInvolved, male, female, sc, st, obc, page]);





  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const startItem = (page - 1) * 10 + 1;
  const endItem = Math.min(page * 10, totalItems);

  const renderPaginationItems = () => {
    const paginationItems = [];
    const maxPagesToShow = 7;
    const startPages = 3;
    const endPages = 2;

    if (totalpage <= maxPagesToShow) {
      for (let pages = 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    } else {
      // Show first 3 pages
      for (let pages = 1; pages <= startPages; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      // Show ellipsis if necessary
      if (page > startPages + 1) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }

      // Show the middle pages around the current page
      const middlePages = [];
      const startMiddlePage = Math.max(page - 1, startPages + 1);
      const endMiddlePage = Math.min(page + 1, totalpage - endPages);

      for (let pages = startMiddlePage; pages <= endMiddlePage; pages++) {
        middlePages.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      paginationItems.push(...middlePages);

      // Show ellipsis if necessary
      if (page < totalpage - endPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      // Show last 2 pages
      for (let pages = totalpage - endPages + 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    }
    return paginationItems;
  };


  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const exportToCSV = async (selectedYear) => {
    const payload = {
      seedClass: "FS",
      villageName: village || "",
      gpName: gp || "",
      blockName: block || "",
      districtName: district || "",
      mipName: mip || "",
      seed: crop || "",
      variety: variety || "",
      // season: "",
      seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,

      area: area || null,
      quantity: certifiedSeed || null,
      pageNumber: page,
      year: year ? Number(year) : null,
    };

    try {
      const response = await apiService.post("/crops/seed-class-wise-report", payload, {
        headers: {
          "Content-Type": "application/json"
        }
      });

      const data = response.data;
      if (!data.body || !data.body.data || data.body.data.length === 0) {
        alert("No data available for the selected year.");
        return;
      }

      const headers = [
        "Village Name", "GP Name", "Block Name", "District Name", "MIP Name", "Seed",
        "Variety", "Season", "Area", "Quantity", "Farmers Involved", "Male", "Female", "SC", "ST", "OBC"
      ];

      const rows = data.body.data.map(item => [
        item.villageName || "",
        item.gpName || "",
        item.blockName || "",
        item.DistrictName || "",
        item.MIPName || "",
        item.seed || "",
        item.variety || "",
        item.season || "",
        item.area || "",
        item.quantity || "",
        item.farmersInvolved || "",
        item.male || "",
        item.female || "",
        item.sc || "",
        item.st || "",
        item.obc || ""
      ]);

      const reportRow = [`Report: ${reportName}`];
      const yearRow = [`Year: ${selectedYear}`];
      const csvContent = [reportRow.join(","), yearRow.join(","), headers.join(","), ...rows.map(row => row.join(","))].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${reportRow}_${selectedYear}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("Failed to fetch data for CSV export.");
    }
  };




  const exportToXLSX = async (selectedYear) => {
    const payload = {
      seedClass: "FS",
      villageName: village || "",
      gpName: gp || "",
      blockName: block || "",
      districtName: district || "",
      mipName: mip || "",
      seed: crop || "",
      variety: variety || "",
      // season: "",
      seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,

      area: area || null,
      quantity: certifiedSeed || null,
      pageNumber: page,
      year: year ? Number(year) : null,
    };

    try {
      const response = await apiService.post("/crops/seed-class-wise-report", payload, {
        headers: { "Content-Type": "application/json" }
      });

      if (!response.data.body || !response.data.body.data || response.data.body.data.length === 0) {
        alert("No data available for the selected year.");
        return;
      }

      const headers = [
        "Village Name", "GP Name", "Block Name", "District Name", "MIP Name", "Seed",
        "Variety", "Season", "Area", "Foundation-Seed Quantity", "Farmers Involved", "Male", "Female", "SC", "ST", "OBC"
      ];

      const rows = response.data.body.data.map(item => [
        item.villageName || "",
        item.gpName || "",
        item.blockName || "",
        item.DistrictName || "",
        item.MIPName || "",
        item.seed || "",
        item.variety || "",
        item.season || "",
        item.area || "",
        item.quantity || "",
        item.farmersInvolved || "",
        item.male || "",
        item.female || "",
        item.sc || "",
        item.st || "",
        item.obc || ""
      ]);

      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const fileName = `${reportName.replace(/\s+/g, '_')}_${selectedYear}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("Failed to fetch data for XLSX export.");
    }
  };





  return (
    <div className="container-fluid" style={{ maxHeight: "90vh", overflowX: "auto" }}>

      <div className="row mt-3">
        <div className="d-flex align-items-center me-4 p-2 bg-white shadow-sm"
          style={{ position: "sticky", top: 0, zIndex: 10 }}>

          {/* Year Dropdown */}
          <div className="d-flex align-items-center me-3">
            <div className="me-2 fw-bold">Year</div>
            <select
              className="form-select form-select-sm"
              style={{ width: "100px" }}
              value={year || 0}
              onChange={(e) => {
                setYear(Number(e.target.value));
              }}
            >
              <option value={0} disabled>Select a Year</option>
              {years.map((yr) => (
                <option key={yr.yearId} value={yr.yearValue}>
                  {yr.yearValue}
                </option>
              ))}
            </select>


            {/* Season Dropdown */}
            <div className="d-flex align-items-center">

              <Button
                variant="contained"
                color="primary"
                sx={{
                  marginLeft: "20px",
                  padding: "10px 20px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "none",
                  borderRadius: "12px",
                  background: "linear-gradient(90deg, #1976d2, #42a5f5)",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                  "&:hover": {
                    background: "linear-gradient(90deg, #1565c0, #2196f3)",
                  },
                }}
                startIcon={<Download />}
                onClick={handleMenuOpen}
              >
                Export Data
              </Button>

              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem onClick={() => { exportToCSV(year); handleMenuClose(); }}>Download as CSV</MenuItem>
                <MenuItem onClick={() => { exportToXLSX(year); handleMenuClose(); }}>Download as XLSX</MenuItem>
              </Menu>
            </div>

          </div>

        </div></div>

      <div className="row mt-3">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body table-responsive p-0"
              style={{
                minHeight: "60vh",
                overflowX: "auto",
                scrollbarWidth: "thin",
                scrollbarColor: "#ccc transparent",
              }}>
              <table className="table table-hover table-bordered text-nowrap mb-0">
                <thead style={{ whiteSpace: "nowrap" }}>
                  <tr>

                    <th>
                      Village
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={village}
                        onChange={(e) => {
                          setVillage(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      GP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={gp}
                        onChange={(e) => {
                          setGp(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      Block
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={block}
                        onChange={(e) => {
                          setBlock(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      District
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={district}
                        onChange={(e) => {
                          setDistrict(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      MIP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={mip}
                        onChange={(e) => {
                          setMip(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      Crop
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={crop}
                        onChange={(e) => {
                          setCrop(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      Season
                      <br />
                      <select
                        className="form-control form-control-sm"
                        value={selectedSeasonId}
                        onChange={(e) => {
                          setSelectedSeasonId(e.target.value);
                          setPage(1);
                        }}
                      >
                        <option value={0}>All</option>
                        {seasons.map((season) => (
                          <option key={season.seasonId} value={season.seasonId}>
                            {season.seasonName}
                          </option>
                        ))}
                      </select>
                    </th>
                    <th>
                      Variety
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={variety}
                        onChange={(e) => {
                          setVariety(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      Area (ha.)
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={area}
                onChange={(e) => {
                  setArea(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th>
                      Qty of FS produced
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={certifiedSeed}
                onChange={(e) => {
                  setCertifiedSeed(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th>
                      Farmers Involved
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={farmersInvolved}
                onChange={(e) => {
                  setFarmersInvolved(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th>
                      Male
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={male}
                onChange={(e) => {
                  setMale(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th>
                      Female
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={female}
                onChange={(e) => {
                  setFemale(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th>
                      SC
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={sc}
                onChange={(e) => {
                  setSc(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th>
                      ST
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={st}
                onChange={(e) => {
                  setSt(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th>
                      OBC
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={obc}
                onChange={(e) => {
                  setObc(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>


                  </tr>
                </thead>
                <tbody style={{ fontSize: "14px" }}>
                  {filteredRows.map((data, index) => (
                    <tr key={index}>
                      <td>{data.villageName}</td>
                      <td>{data.gpName}</td>
                      <td>{data.blockName}</td>
                      <td>{data.districtName}</td>
                      <td>{data.mipName}</td>
                      <td>{data.seed}</td>
                      <td>{data.season}</td>
                      <td>{data.variety}</td>
                      <td>{data.area}</td>
                      <td>{data.quantity}</td>
                      <td>{data.farmersInvolved}</td>
                      <td>{data.male}</td>
                      <td>{data.female}</td>
                      <td>{data.sc}</td>
                      <td>{data.st}</td>
                      <td>{data.obc}</td>

                    </tr>
                  ))}
                </tbody>
              </table>
            </div></div></div></div>

      <div className="row mt-3">
        <div className='d-flex justify-content-between pb-0'>
          <div className='p-2'>
            Showing {startItem} to {endItem} of {totalItems} items
          </div>
          <div className='p-2'>
            <Pagination className="mb-0">
              <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
              <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
              {renderPaginationItems()}
              <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalpage} />
              <Pagination.Last onClick={() => handlePageChange(totalpage)} disabled={page === totalpage} />
            </Pagination>
          </div>
        </div>
      </div>

    </div>
  );
};

const Foundationtocertified = ({ reportName }) => {
  const [filteredRows, setFilteredRows] = useState([]);
  const [season, setSeason] = useState("");
  const [dist, setDist] = useState("");
  const [block, setBlock] = useState("");
  const [mip, setMip] = useState("");
  const [crop, setCrop] = useState("");
  const [obc, setObc] = useState("");
  const [village, setVillage] = useState("");
  const [gp, setGp] = useState("");
  const [district, setDistrict] = useState("");
  const [variety, setVariety] = useState("");
  const [area, setArea] = useState("");
  const [certifiedSeed, setCertifiedSeed] = useState("");
  const [farmersInvolved, setFarmersInvolved] = useState("");
  const [page, setPage] = useState(1);
  const [male, setMale] = useState("");
  const [female, setFemale] = useState("");
  const [sc, setSc] = useState("");
  const [st, setSt] = useState("");
  const [year, setYear] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [totalItems, setTotalitems] = useState(0);
  const [totalpage, setTotalpage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectedSeasonId, setSelectedSeasonId] = useState(0);
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  const fetchYears = async () => {
    try {
      const response = await apiService.get("/years/get-all");
      setYears(response.data);
      const currentYear = new Date().getFullYear();
      const defaultYear = response.data.find((yr) => yr.yearValue === currentYear);

      setYear(defaultYear ? defaultYear.yearValue : response.data[0].yearValue);
    } catch (error) {
      console.error("Error fetching years:", error);
    }
  };


  useEffect(() => {

    fetchYears();
  }, []);

  const fetchSeasons = async () => {
    try {
      const response = await apiService.get("/seasons/get-all");
      setSeasons(response.data);
    } catch (error) {
      console.error("Error fetching seasons:", error);
    }
  };



  useEffect(() => {

    fetchYears();
    fetchSeasons();
  }, []);



  const fetchData = async () => {
    const payload = {
      seedClass: "CS",
      villageName: village || "",
      gpName: gp || "",
      blockName: block || "",
      districtName: district || "",
      mipName: mip || "",
      seed: crop || "",
      variety: variety || "",
      // season: "",
      seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,

      area: area || null,
      quantity: certifiedSeed || null,
      pageNumber: page,
      pageSize: pageSize,
      year: year ? Number(year) : null,
    };

    try {
      const response = await apiService.post("/crops/seed-class-wise-report", payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.data.status) {
        setFilteredRows(response.data.body.data || []);
        const data = response.data.body.data || [];
        const totalRecords = response.data.body.recordsCount || 0;
        const totalPages = pageSize > 0 ? Math.ceil(totalRecords / pageSize) : 0;

        setFilteredRows(data);
        setTotalitems(totalRecords);
        setTotalpage(totalPages);
        setRows(data);
        setRowCount(totalRecords);
      } else {
        console.error("Error fetching data:", response.data.message);
        setFilteredRows([]);
        setTotalitems(0);
        setTotalpage(0);
        setRows([]);
        setRowCount(0);
      }
    } catch (error) {
      console.error("API call failed:", error);
      setFilteredRows([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, [village, gp, block, district, mip, crop, season, variety, area, selectedSeasonId, certifiedSeed, year, farmersInvolved, male, female, sc, st, obc, page]);





  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const startItem = (page - 1) * 10 + 1;
  const endItem = Math.min(page * 10, totalItems);

  const renderPaginationItems = () => {
    const paginationItems = [];
    const maxPagesToShow = 7;
    const startPages = 3;
    const endPages = 2;

    if (totalpage <= maxPagesToShow) {
      for (let pages = 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    } else {
      // Show first 3 pages
      for (let pages = 1; pages <= startPages; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      // Show ellipsis if necessary
      if (page > startPages + 1) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }

      // Show the middle pages around the current page
      const middlePages = [];
      const startMiddlePage = Math.max(page - 1, startPages + 1);
      const endMiddlePage = Math.min(page + 1, totalpage - endPages);

      for (let pages = startMiddlePage; pages <= endMiddlePage; pages++) {
        middlePages.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      paginationItems.push(...middlePages);

      // Show ellipsis if necessary
      if (page < totalpage - endPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      // Show last 2 pages
      for (let pages = totalpage - endPages + 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    }
    return paginationItems;
  };


  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const exportToCSV = async (selectedYear) => {
    const payload = {
      seedClass: "CS",
      villageName: village || "",
      gpName: gp || "",
      blockName: block || "",
      districtName: district || "",
      mipName: mip || "",
      seed: crop || "",
      variety: variety || "",
      // season: "",
      seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,

      area: area || null,
      quantity: certifiedSeed || null,
      pageNumber: page,
      year: year ? Number(year) : null,
    };

    try {
      const response = await apiService.post("/crops/seed-class-wise-report", payload, {
        headers: {
          "Content-Type": "application/json"
        }
      });

      const data = response.data;
      if (!data.body || !data.body.data || data.body.data.length === 0) {
        alert("No data available for the selected year.");
        return;
      }

      const headers = [
        "Village Name", "GP Name", "Block Name", "District Name", "MIP Name", "Seed",
        "Variety", "Season", "Area", "Quantity", "Farmers Involved", "Male", "Female", "SC", "ST", "OBC"
      ];

      const rows = data.body.data.map(item => [
        item.villageName || "",
        item.gpName || "",
        item.blockName || "",
        item.DistrictName || "",
        item.MIPName || "",
        item.seed || "",
        item.variety || "",
        item.season || "",
        item.area || "",
        item.quantity || "",
        item.farmersInvolved || "",
        item.male || "",
        item.female || "",
        item.sc || "",
        item.st || "",
        item.obc || ""
      ]);

      const reportRow = [`Report: ${reportName}`];
      const yearRow = [`Year: ${selectedYear}`];
      const csvContent = [reportRow.join(","), yearRow.join(","), headers.join(","), ...rows.map(row => row.join(","))].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${reportRow}_${selectedYear}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("Failed to fetch data for CSV export.");
    }
  };




  const exportToXLSX = async (selectedYear) => {
    const payload = {
      seedClass: "CS",
      villageName: village || "",
      gpName: gp || "",
      blockName: block || "",
      districtName: district || "",
      mipName: mip || "",
      seed: crop || "",
      variety: variety || "",
      // season: "",
      seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,

      area: area || null,
      quantity: certifiedSeed || null,
      pageNumber: page,
      year: year ? Number(year) : null,
    };

    try {
      const response = await apiService.post("/crops/seed-class-wise-report", payload, {
        headers: { "Content-Type": "application/json" }
      });

      if (!response.data.body || !response.data.body.data || response.data.body.data.length === 0) {
        alert("No data available for the selected year.");
        return;
      }

      const headers = [
        "Village Name", "GP Name", "Block Name", "District Name", "MIP Name", "Seed",
        "Variety", "Season", "Area", "Certified-Seed Quantity", "Farmers Involved", "Male", "Female", "SC", "ST", "OBC"
      ];

      const rows = response.data.body.data.map(item => [
        item.villageName || "",
        item.gpName || "",
        item.blockName || "",
        item.DistrictName || "",
        item.MIPName || "",
        item.seed || "",
        item.variety || "",
        item.season || "",
        item.area || "",
        item.quantity || "",
        item.farmersInvolved || "",
        item.male || "",
        item.female || "",
        item.sc || "",
        item.st || "",
        item.obc || ""
      ]);

      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const fileName = `${reportName.replace(/\s+/g, '_')}_${selectedYear}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("Failed to fetch data for XLSX export.");
    }
  };




  return (
    <div className="container-fluid" style={{ maxHeight: "100vh", overflowX: "auto" }}>


      <div className="row mt-3">
        <div className="d-flex align-items-center me-4 p-2 bg-white shadow-sm"

          style={{ position: "sticky", top: 0, zIndex: 10 }}>

          {/* Year Dropdown */}
          <div className="d-flex align-items-center me-3">
            <div className="me-2 fw-bold">Year</div>
            <select
              className="form-select form-select-sm"
              style={{ width: "100px" }}
              value={year || 0}
              onChange={(e) => {
                setYear(Number(e.target.value));
              }}
            >
              <option value={0} disabled>Select a Year</option>
              {years.map((yr) => (
                <option key={yr.yearId} value={yr.yearValue}>
                  {yr.yearValue}
                </option>
              ))}
            </select>


            {/* Season Dropdown */}
            <div className="d-flex align-items-center">

              <Button
                variant="contained"
                color="primary"
                sx={{
                  marginLeft: "20px",
                  padding: "10px 20px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "none",
                  borderRadius: "12px",
                  background: "linear-gradient(90deg, #1976d2, #42a5f5)",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                  "&:hover": {
                    background: "linear-gradient(90deg, #1565c0, #2196f3)",
                  },
                }}
                startIcon={<Download />}
                onClick={handleMenuOpen}
              >
                Export Data
              </Button>

              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem onClick={() => { exportToCSV(year); handleMenuClose(); }}>Download as CSV</MenuItem>
                <MenuItem onClick={() => { exportToXLSX(year); handleMenuClose(); }}>Download as XLSX</MenuItem>
              </Menu>
            </div>

          </div>

        </div></div>

      <div className="row mt-3">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body table-responsive p-0"
              style={{
                minHeight: "60vh",
                overflowX: "auto",
                scrollbarWidth: "thin",
                scrollbarColor: "#ccc transparent",
              }}>
              <table className="table table-hover table-bordered text-nowrap mb-0">
                <thead style={{ whiteSpace: "nowrap" }}>
                  <tr>

                    <th>
                      Village
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={village}
                        onChange={(e) => {
                          setVillage(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      GP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={gp}
                        onChange={(e) => {
                          setGp(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      Block
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={block}
                        onChange={(e) => {
                          setBlock(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      District
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={district}
                        onChange={(e) => {
                          setDistrict(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      MIP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={mip}
                        onChange={(e) => {
                          setMip(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      Crop
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={crop}
                        onChange={(e) => {
                          setCrop(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      Season
                      <br />
                      <select
                        className="form-control form-control-sm"
                        value={selectedSeasonId}
                        onChange={(e) => {
                          setSelectedSeasonId(e.target.value);
                          setPage(1);
                        }}
                      >
                        <option value={0}>All</option>
                        {seasons.map((season) => (
                          <option key={season.seasonId} value={season.seasonId}>
                            {season.seasonName}
                          </option>
                        ))}
                      </select>
                    </th>
                    <th>
                      Variety
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={variety}
                        onChange={(e) => {
                          setVariety(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      Area (ha.)
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={area}
                onChange={(e) => {
                  setArea(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th>
                      Qty of CS produced
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={certifiedSeed}
                onChange={(e) => {
                  setCertifiedSeed(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th>
                      Farmers Involved
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={farmersInvolved}
                onChange={(e) => {
                  setFarmersInvolved(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th>
                      Male
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={male}
                onChange={(e) => {
                  setMale(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th>
                      Female
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={female}
                onChange={(e) => {
                  setFemale(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th>
                      SC
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={sc}
                onChange={(e) => {
                  setSc(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th>
                      ST
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={st}
                onChange={(e) => {
                  setSt(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th>
                      OBC
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={obc}
                onChange={(e) => {
                  setObc(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>


                  </tr>
                </thead>
                <tbody style={{ fontSize: "14px" }}>
                  {filteredRows.map((data, index) => (
                    <tr key={index}>
                      <td>{data.villageName}</td>
                      <td>{data.gpName}</td>
                      <td>{data.blockName}</td>
                      <td>{data.districtName}</td>
                      <td>{data.mipName}</td>
                      <td>{data.seed}</td>
                      <td>{data.season}</td>
                      <td>{data.variety}</td>
                      <td>{data.area}</td>
                      <td>{data.quantity}</td>
                      <td>{data.farmersInvolved}</td>
                      <td>{data.male}</td>
                      <td>{data.female}</td>
                      <td>{data.sc}</td>
                      <td>{data.st}</td>
                      <td>{data.obc}</td>

                    </tr>
                  ))}
                </tbody>
              </table>
            </div></div></div></div>

      <div className="row mt-3">
        <div className='d-flex justify-content-between pb-0'>
          <div className='p-2'>
            Showing {startItem} to {endItem} of {totalItems} items
          </div>
          <div className='p-2'>
            <Pagination className="mb-0">
              <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
              <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
              {renderPaginationItems()}
              <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalpage} />
              <Pagination.Last onClick={() => handlePageChange(totalpage)} disabled={page === totalpage} />
            </Pagination>
          </div>
        </div>
      </div>

    </div>
  );
};



const CertifiedtoUpscalling = ({ reportName }) => {
  const [filteredRows, setFilteredRows] = useState([]);
  const [season, setSeason] = useState("");
  const [dist, setDist] = useState("");
  const [block, setBlock] = useState("");
  const [mip, setMip] = useState("");
  const [crop, setCrop] = useState("");
  const [obc, setObc] = useState("");
  const [village, setVillage] = useState("");
  const [gp, setGp] = useState("");
  const [district, setDistrict] = useState("");
  const [variety, setVariety] = useState("");
  const [area, setArea] = useState("");
  const [certifiedSeed, setCertifiedSeed] = useState("");
  const [farmersInvolved, setFarmersInvolved] = useState("");
  const [page, setPage] = useState(1);
  const [male, setMale] = useState("");
  const [female, setFemale] = useState("");
  const [sc, setSc] = useState("");
  const [st, setSt] = useState("");
  const [year, setYear] = useState(new Date().getFullYear());
  const [years, setYears] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [totalItems, setTotalitems] = useState(0);
  const [totalpage, setTotalpage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [selectedSeasonId, setSelectedSeasonId] = useState(0);
  const [rows, setRows] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  const fetchYears = async () => {
    try {
      const response = await apiService.get("/years/get-all");
      setYears(response.data);
      const currentYear = new Date().getFullYear();
      const defaultYear = response.data.find((yr) => yr.yearValue === currentYear);

      setYear(defaultYear ? defaultYear.yearValue : response.data[0].yearValue);
    } catch (error) {
      console.error("Error fetching years:", error);
    }
  };


  useEffect(() => {

    fetchYears();
  }, []);

  const fetchSeasons = async () => {
    try {
      const response = await apiService.get("/seasons/get-all");
      setSeasons(response.data);
    } catch (error) {
      console.error("Error fetching seasons:", error);
    }
  };



  useEffect(() => {

    fetchYears();
    fetchSeasons();
  }, []);



  const fetchData = async () => {
    const payload = {
      seedClass: "TL",
      villageName: village || "",
      gpName: gp || "",
      blockName: block || "",
      districtName: district || "",
      mipName: mip || "",
      seed: crop || "",
      variety: variety || "",
      // season: "",
      seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,

      area: area || null,
      quantity: certifiedSeed || null,
      pageNumber: page,
      pageSize: pageSize,
      year: year ? Number(year) : null,
    };

    try {
      const response = await apiService.post("/crops/seed-class-wise-report", payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.data.status) {
        setFilteredRows(response.data.body.data || []);
        const data = response.data.body.data || [];
        const totalRecords = response.data.body.recordsCount || 0;
        const totalPages = pageSize > 0 ? Math.ceil(totalRecords / pageSize) : 0;

        setFilteredRows(data);
        setTotalitems(totalRecords);
        setTotalpage(totalPages);
        setRows(data);
        setRowCount(totalRecords);
      } else {
        console.error("Error fetching data:", response.data.message);
        setFilteredRows([]);
        setTotalitems(0);
        setTotalpage(0);
        setRows([]);
        setRowCount(0);
      }
    } catch (error) {
      console.error("API call failed:", error);
      setFilteredRows([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, [village, gp, block, district, mip, crop, season, variety, area, selectedSeasonId, certifiedSeed, year, farmersInvolved, male, female, sc, st, obc, page]);





  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const startItem = (page - 1) * 10 + 1;
  const endItem = Math.min(page * 10, totalItems);

  const renderPaginationItems = () => {
    const paginationItems = [];
    const maxPagesToShow = 7;
    const startPages = 3;
    const endPages = 2;

    if (totalpage <= maxPagesToShow) {
      for (let pages = 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    } else {
      // Show first 3 pages
      for (let pages = 1; pages <= startPages; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      // Show ellipsis if necessary
      if (page > startPages + 1) {
        paginationItems.push(<Pagination.Ellipsis key="start-ellipsis" />);
      }

      // Show the middle pages around the current page
      const middlePages = [];
      const startMiddlePage = Math.max(page - 1, startPages + 1);
      const endMiddlePage = Math.min(page + 1, totalpage - endPages);

      for (let pages = startMiddlePage; pages <= endMiddlePage; pages++) {
        middlePages.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }

      paginationItems.push(...middlePages);

      // Show ellipsis if necessary
      if (page < totalpage - endPages - 1) {
        paginationItems.push(<Pagination.Ellipsis key="end-ellipsis" />);
      }

      // Show last 2 pages
      for (let pages = totalpage - endPages + 1; pages <= totalpage; pages++) {
        paginationItems.push(
          <Pagination.Item key={pages} active={page === pages} onClick={() => handlePageChange(pages)}>
            {pages}
          </Pagination.Item>
        );
      }
    }
    return paginationItems;
  };


  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const exportToCSV = async (selectedYear) => {
    const payload = {
      seedClass: "TL",
      villageName: village || "",
      gpName: gp || "",
      blockName: block || "",
      districtName: district || "",
      mipName: mip || "",
      seed: crop || "",
      variety: variety || "",
      // season: "",
      seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,

      area: area || null,
      quantity: certifiedSeed || null,
      pageNumber: page,
      year: year ? Number(year) : null,
    };

    try {
      const response = await apiService.post("/crops/seed-class-wise-report", payload, {
        headers: {
          "Content-Type": "application/json"
        }
      });

      const data = response.data;
      if (!data.body || !data.body.data || data.body.data.length === 0) {
        alert("No data available for the selected year.");
        return;
      }

      const headers = [
        "Village Name", "GP Name", "Block Name", "District Name", "MIP Name", "Seed",
        "Variety", "Season", "Area", "Quantity of Tl-Seed"
      ];

      const rows = data.body.data.map(item => [
        item.villageName || "",
        item.gpName || "",
        item.blockName || "",
        item.DistrictName || "",
        item.MIPName || "",
        item.seed || "",
        item.variety || "",
        item.season || "",
        item.area || "",
        item.quantity || "",
        // item.farmersInvolved || "",
        // item.male || "",
        // item.female || "",
        // item.sc || "",
        // item.st || "",
        // item.obc || ""
      ]);

      const reportRow = [`Report: ${reportName}`];
      const yearRow = [`Year: ${selectedYear}`];
      const csvContent = [reportRow.join(","), yearRow.join(","), headers.join(","), ...rows.map(row => row.join(","))].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${reportRow}_${selectedYear}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("Failed to fetch data for CSV export.");
    }
  };




  const exportToXLSX = async (selectedYear) => {
    const payload = {
      seedClass: "TL",
      villageName: village || "",
      gpName: gp || "",
      blockName: block || "",
      districtName: district || "",
      mipName: mip || "",
      seed: crop || "",
      variety: variety || "",
      // season: "",
      seasonId: selectedSeasonId ? Number(selectedSeasonId) : 0,

      area: area || null,
      quantity: certifiedSeed || null,
      pageNumber: page,
      year: year ? Number(year) : null,
    };

    try {
      const response = await apiService.post("/crops/seed-class-wise-report", payload, {
        headers: { "Content-Type": "application/json" }
      });

      if (!response.data.body || !response.data.body.data || response.data.body.data.length === 0) {
        alert("No data available for the selected year.");
        return;
      }

      const headers = [
        "Village Name", "GP Name", "Block Name", "District Name", "MIP Name", "Seed",
        "Variety", "Season", "Area", "Quantity of Tl-seed"
      ];

      const rows = response.data.body.data.map(item => [
        item.villageName || "",
        item.gpName || "",
        item.blockName || "",
        item.DistrictName || "",
        item.MIPName || "",
        item.seed || "",
        item.variety || "",
        item.season || "",
        item.area || "",
        item.quantity || "",
        // item.farmersInvolved || "",
        // item.male || "",
        // item.female || "",
        // item.sc || "",
        // item.st || "",
        // item.obc || ""
      ]);

      const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const fileName = `${reportName.replace(/\s+/g, '_')}_${selectedYear}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("Failed to fetch data for XLSX export.");
    }
  };





  return (
    <div className="container-fluid" style={{ maxHeight: "100vh", overflowX: "auto" }}>
      <div className="row mt-3">
        <div className="d-flex align-items-center me-4 p-2 bg-white shadow-sm"
          style={{ position: "sticky", top: 0, zIndex: 10 }}>

          {/* Year Dropdown */}
          <div className="d-flex align-items-center me-3">
            <div className="me-2 fw-bold">Year</div>
            <select
              className="form-select form-select-sm"
              style={{ width: "100px" }}
              value={year || 0}
              onChange={(e) => {
                setYear(Number(e.target.value));
              }}
            >
              <option value={0} disabled>Select a Year</option>
              {years.map((yr) => (
                <option key={yr.yearId} value={yr.yearValue}>
                  {yr.yearValue}
                </option>
              ))}
            </select>


            {/* Season Dropdown */}
            <div className="d-flex align-items-center">

              <Button
                variant="contained"
                color="primary"
                sx={{
                  marginLeft: "20px",
                  padding: "10px 20px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  textTransform: "none",
                  borderRadius: "12px",
                  background: "linear-gradient(90deg, #1976d2, #42a5f5)",
                  boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)",
                  "&:hover": {
                    background: "linear-gradient(90deg, #1565c0, #2196f3)",
                  },
                }}
                startIcon={<Download />}
                onClick={handleMenuOpen}
              >
                Export Data
              </Button>

              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem onClick={() => { exportToCSV(year); handleMenuClose(); }}>Download as CSV</MenuItem>
                <MenuItem onClick={() => { exportToXLSX(year); handleMenuClose(); }}>Download as XLSX</MenuItem>
              </Menu>
            </div>

          </div>

        </div></div>

      <div className="row mt-3">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-body table-responsive p-0"
              style={{
                minHeight: "60vh",
                overflowX: "auto",
                scrollbarWidth: "thin",
                scrollbarColor: "#ccc transparent",
              }}>
              <table className="table table-hover table-bordered text-nowrap mb-0">
                <thead style={{ whiteSpace: "nowrap" }}>
                  <tr>

                    <th>
                      Village
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={village}
                        onChange={(e) => {
                          setVillage(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      GP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={gp}
                        onChange={(e) => {
                          setGp(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      Block
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={block}
                        onChange={(e) => {
                          setBlock(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      District
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={district}
                        onChange={(e) => {
                          setDistrict(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      MIP
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={mip}
                        onChange={(e) => {
                          setMip(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      Crop
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={crop}
                        onChange={(e) => {
                          setCrop(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      Season
                      <br />
                      <select
                        className="form-control form-control-sm"
                        value={selectedSeasonId}
                        onChange={(e) => {
                          setSelectedSeasonId(e.target.value);
                          setPage(1);
                        }}
                      >
                        <option value={0}>All</option>
                        {seasons.map((season) => (
                          <option key={season.seasonId} value={season.seasonId}>
                            {season.seasonName}
                          </option>
                        ))}
                      </select>
                    </th>
                    <th>
                      Variety
                      <br />
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                        value={variety}
                        onChange={(e) => {
                          setVariety(e.target.value);
                          setPage(1);
                        }}
                      />
                    </th>
                    <th>
                      Area (ha.)
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={area}
                onChange={(e) => {
                  setArea(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>
                    <th>
                      Quantity of Tl-Seed
                      <br />
                      {/* <input
                type="text"
                placeholder="Search"
                className="form-control form-control-sm"
                value={certifiedSeed}
                onChange={(e) => {
                  setCertifiedSeed(e.target.value);
                  setPage(1);
                }}
              /> */}
                    </th>

                  </tr>
                </thead>
                <tbody style={{ fontSize: "14px" }}>
                  {filteredRows.map((data, index) => (
                    <tr key={index}>
                      <td>{data.villageName}</td>
                      <td>{data.gpName}</td>
                      <td>{data.blockName}</td>
                      <td>{data.DistrictName}</td>
                      <td>{data.MIPName}</td>
                      <td>{data.seed}</td>
                      <td>{data.season}</td>
                      <td>{data.variety}</td>
                      <td>{data.area}</td>
                      <td>{data.quantity}</td>
                      {/* <td>{data.farmersInvolved}</td>
            <td>{data.male}</td>
            <td>{data.female}</td>
            <td>{data.sc}</td>
            <td>{data.st}</td>
            <td>{data.obc}</td> */}

                    </tr>
                  ))}
                </tbody>
              </table>
            </div></div></div></div>

      <div className="row mt-3">
        <div className='d-flex justify-content-between pb-0'>
          <div className='p-2'>
            Showing {startItem} to {endItem} of {totalItems} items
          </div>
          <div className='p-2'>
            <Pagination className="mb-0">
              <Pagination.First onClick={() => handlePageChange(1)} disabled={page === 1} />
              <Pagination.Prev onClick={() => handlePageChange(page - 1)} disabled={page === 1} />
              {renderPaginationItems()}
              <Pagination.Next onClick={() => handlePageChange(page + 1)} disabled={page === totalpage} />
              <Pagination.Last onClick={() => handlePageChange(totalpage)} disabled={page === totalpage} />
            </Pagination>
          </div>
        </div>
      </div>

    </div>
  );
};

// const Reports = () => {
//   const [options, setOptions] = useState([]);
//   const [selectedValue, setSelectedValue] = useState("");

//   useEffect(() => {
//     apiService.get("/get-report-titles")
//       .then(response => {
//         if (response.data && response.data.length > 0) {
//           setOptions(response.data);
//           setSelectedValue(response.data[0].ReportTitle); // Set default
//         }
//       })
//       .catch(error => {
//         console.error("Error fetching report titles:", error);
//       });
//   }, []);

//   const handleSelectChange = (event) => {
//     setSelectedValue(event.target.value);
//   };

//   return (
//     <div style={{ padding: "20px" }}>
//       <div style={{ display: "flex", alignItems: "center", gap: "20px", marginBottom: "20px" }}>
//         <h1 style={{ margin: 0 }}>Reports</h1>
//         <select
//           value={selectedValue}
//           onChange={handleSelectChange}
//           style={{ padding: "8px", fontSize: "16px", width: "400px", height: "40px" }}
//         >
//           {options.map((option, index) => (
//             <option key={option.ReportId} value={option.ReportTitle}>
//               {index + 1}. {option.ReportTitle}
//             </option>
//           ))}
//         </select>
//       </div>

//       {selectedValue === "Cropplan Farmerwise Information" && <CropPlan reportName={selectedValue} />}
//       {selectedValue === "Crop-Cultivation Farmerwise Information" && <CropCulltivation reportName={selectedValue} />}
//       {selectedValue === "Crop Production Farmerwise Information" && <CropProduction reportName={selectedValue} />}
//       {selectedValue === "Marketlinkage Farmerwise Information" && <Marketlinkage reportName={selectedValue} />}
//       {selectedValue === "Production-Crop Area Coverage (ha) Farmerwise" && <Productioncroparea reportName={selectedValue} />}
//       {selectedValue === "Cluster Training FPC and PGS" && <Clusterdata reportName={selectedValue} />}
//       {selectedValue === "Pulses Variety and Technology Park" && <PalsesVariety reportName={selectedValue} />}
//       {selectedValue === "Breeder to Foundation Seed Multiplication by FPC for Released Varieties of Pulses" && <Breedertofoundation reportName={selectedValue} />}
//       {selectedValue === "Foundation to Certified Seed Production by PGs" && <Foundationtocertified reportName={selectedValue} />}
//       {selectedValue === "Certified To Upscalling Seed Production by PGs" && <CertifiedtoUpscalling reportName={selectedValue} />}

//     </div>
//   );
// };


const Reports = () => {
  const [options, setOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");

  useEffect(() => {
    apiService.get("/get-report-titles")
      .then(response => {
        if (response.data && response.data.length > 0) {
          const filteredOptions = response.data.filter(
            (option) => option.ReportTitle !== "Production-Crop Area Coverage (ha) Farmerwise"
          );

          setOptions(filteredOptions);

          if (filteredOptions.length > 0) {
            setSelectedValue(filteredOptions[0].ReportTitle);
          } else {
            setSelectedValue("");
          }
        }
      })
      .catch(error => {
        console.error("Error fetching report titles:", error);
      });
  }, []);

  const handleSelectChange = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <div style={{ padding: "20px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "20px", marginBottom: "20px" }}>
        <h1 style={{ margin: 0 }}>Reports</h1>
        <select
          value={selectedValue}
          onChange={handleSelectChange}
          style={{ padding: "8px", fontSize: "16px", width: "400px", height: "40px" }}
        >
          {options.map((option, index) => (
            <option key={option.ReportId} value={option.ReportTitle}>
              {index + 1}. {option.ReportTitle}
            </option>
          ))}
        </select>
      </div>

      {selectedValue === "Cropplan Farmerwise Information" && <CropPlan reportName={selectedValue} />}
      {selectedValue === "Crop-Cultivation Farmerwise Information" && <CropCulltivation reportName={selectedValue} />}
      {selectedValue === "Crop Production Farmerwise Information" && <CropProduction reportName={selectedValue} />}
      {selectedValue === "Marketlinkage Farmerwise Information" && <Marketlinkage reportName={selectedValue} />}
      {selectedValue === "Cluster Training FPC and PGS" && <Clusterdata reportName={selectedValue} />}
      {selectedValue === "Pulses Variety and Technology Park" && <PalsesVariety reportName={selectedValue} />}
      {selectedValue === "Breeder to Foundation Seed Multiplication by FPC for Released Varieties of Pulses" && <Breedertofoundation reportName={selectedValue} />}
      {selectedValue === "Foundation to Certified Seed Production by PGs" && <Foundationtocertified reportName={selectedValue} />}
      {selectedValue === "Certified To Upscalling Seed Production by PGs" && <CertifiedtoUpscalling reportName={selectedValue} />}
    </div>
  );
};

export default Reports;
